// // // // // // // src/utils/servicesConfig.js
// // // // // // //
// // // // // // // ═══════════════════════════════════════════════════════════════
// // // // // // // HOW TO CONFIGURE
// // // // // // // ═══════════════════════════════════════════════════════════════
// // // // // // //
// // // // // // // ADD A NEW PLAN:
// // // // // // //   1. Add to plans[] with unique id, price, includes[]
// // // // // // //   2. Add price to backend/server.js PLAN_PRICES
// // // // // // //   3. Set enabled/active: true when ready
// // // // // // //
// // // // // // // ADD A NEW SERVICE:
// // // // // // //   1. Add to services[] with unique serviceCode
// // // // // // //   2. Add serviceCode to relevant plan includes[]
// // // // // // //
// // // // // // // ADD A NEW RESUME TEMPLATE:
// // // // // // //   1. Add to resumeTemplates[] with unique id
// // // // // // //   2. Add id to relevant plan resumeTemplateIds[]
// // // // // // //   3. Add rendering in ResumeGeneratorPage.jsx
// // // // // // //   4. Add styling in generateResumeDoc.js
// // // // // // //
// // // // // // // CONTROL TEMPLATE ACCESS PER PLAN:
// // // // // // //   Set resumeTemplateCount — how many templates user can choose from
// // // // // // //   Set resumeTemplateIds   — which specific templates are available
// // // // // // //
// // // // // // // ═══════════════════════════════════════════════════════════════

// // // // // // const servicesConfig = {

// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   // APP BRANDING — change here, updates everywhere automatically
// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   app: {
// // // // // //     name:        "ResumeScoreAI",
// // // // // //     tagline:     "Beat the ATS. Get the interview.",        // ← hero headline suffix
// // // // // //     taglinePre:  "Beat the ATS.",                           // ← line 1 of split tagline
// // // // // //     taglinePost: "Land more interviews.",                      // ← line 2 of split tagline
// // // // // //     description: "AI-powered ATS resume analysis and generation — beat the ATS, get the interview.",
// // // // // //     shortDesc:   "Beat the ATS. Get the interview.",        // ← used in meta, footer
// // // // // //     ctaHero:     "Analyze My Resume",                       // ← primary CTA button text
// // // // // //     ctaNav:      "Get Started Free",                        // ← nav CTA for logged-out
// // // // // //     ctaNavUser:  "New Analysis",                            // ← nav CTA for logged-in
// // // // // //     supportHours:"48 hours",                                // ← support response time
// // // // // //     domain:      "smartaicareer.com",
// // // // // //     email:       "support@smartaicareer.com",
// // // // // //     twitter:     "",
// // // // // //     linkedin:    "",
// // // // // //   },

// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   // RESUME TEMPLATES
// // // // // //   // Single source of truth for all available templates.
// // // // // //   // Access per plan is controlled via plan.resumeTemplateIds[]
// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   // RESUME TEMPLATES
// // // // // //   //
// // // // // //   // Each template has these control flags:
// // // // // //   //   active:     true  → built, tested, available for use
// // // // // //   //               false → disabled globally (not shown anywhere)
// // // // // //   //   showInLanding: true  → shown in landing page carousel
// // // // // //   //   comingSoon: true  → show greyed-out with "Coming Soon" badge
// // // // // //   //
// // // // // //   // Plan access is controlled via plans[].resumeTemplateIds[]
// // // // // //   // To add a new template:
// // // // // //   //   1. Add entry here with active: false, comingSoon: true
// // // // // //   //   2. Build the renderer in TemplateMini.jsx, ResumePreview, generateResumeDoc.js
// // // // // //   //   3. Set active: true when ready
// // // // // //   //   4. Add id to relevant plan's resumeTemplateIds[]
// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   resumeTemplates: [
// // // // // //     {
// // // // // //       id:            "classic",
// // // // // //       name:          "Classic ATS",
// // // // // //       description:   "Clean single-column layout. Best for traditional industries.",
// // // // // //       tags:          ["Finance", "Law", "Healthcare"],
// // // // // //       accent:        "#2563eb",
// // // // // //       headerBg:      "#1e293b",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "modern",
// // // // // //       name:          "Modern Pro",
// // // // // //       description:   "Bold sidebar with skill bars. Great for tech roles.",
// // // // // //       tags:          ["Tech", "Engineering", "Design"],
// // // // // //       accent:        "#7c3aed",
// // // // // //       headerBg:      "#7c3aed",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "executive",
// // // // // //       name:          "Executive",
// // // // // //       description:   "Dark full-width header for senior-level positions.",
// // // // // //       tags:          ["Management", "C-Suite", "Director"],
// // // // // //       accent:        "#0f172a",
// // // // // //       headerBg:      "#0f172a",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "minimal",
// // // // // //       name:          "Minimal Clean",
// // // // // //       description:   "Ultra clean whitespace. Passes all ATS scanners easily.",
// // // // // //       tags:          ["Any Industry", "Entry Level", "Remote"],
// // // // // //       accent:        "#059669",
// // // // // //       headerBg:      "#059669",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "corporate",
// // // // // //       name:          "Corporate",
// // // // // //       description:   "Gradient header with professional layout for business roles.",
// // // // // //       tags:          ["Business", "Consulting", "Banking"],
// // // // // //       accent:        "#0369a1",
// // // // // //       headerBg:      "#0c4a6e",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "creative",
// // // // // //       name:          "Creative",
// // // // // //       description:   "Bold diagonal header with color accents for creative roles.",
// // // // // //       tags:          ["Marketing", "Design", "Media"],
// // // // // //       accent:        "#e11d48",
// // // // // //       headerBg:      "#881337",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "technical",
// // // // // //       name:          "Technical",
// // // // // //       description:   "Code-style layout optimized for engineers and developers.",
// // // // // //       tags:          ["Engineering", "Software", "Data Science"],
// // // // // //       accent:        "#0891b2",
// // // // // //       headerBg:      "#164e63",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "elegant",
// // // // // //       name:          "Elegant",
// // // // // //       description:   "Refined serif typography with a tasteful two-tone sidebar accent.",
// // // // // //       tags:          ["Finance", "Law", "Consulting"],
// // // // // //       accent:        "#b45309",
// // // // // //       headerBg:      "#1c1917",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "bold",
// // // // // //       name:          "Bold Impact",
// // // // // //       description:   "Large name, strong section dividers. Stands out in any stack.",
// // // // // //       tags:          ["Sales", "Marketing", "Operations"],
// // // // // //       accent:        "#1d4ed8",
// // // // // //       headerBg:      "#1e3a8a",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "sidebarlight",
// // // // // //       name:          "Sidebar Light",
// // // // // //       description:   "Clean light sidebar with contact info. Balanced and modern.",
// // // // // //       tags:          ["Product", "Design", "HR"],
// // // // // //       accent:        "#0d9488",
// // // // // //       headerBg:      "#f0fdfa",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     {
// // // // // //       id:            "academic",
// // // // // //       name:          "Academic",
// // // // // //       description:   "Formal layout for research, academia, and PhD applications.",
// // // // // //       tags:          ["Research", "Academia", "Science"],
// // // // // //       accent:        "#7c3aed",
// // // // // //       headerBg:      "#1e1b4b",
// // // // // //       active:        true,
// // // // // //       showInLanding: true,
// // // // // //       comingSoon:    false,
// // // // // //     },
// // // // // //     // ── Future templates — set active:false until renderer is built ──
// // // // // //     // {
// // // // // //     //   id:            "infographic",
// // // // // //     //   name:          "Infographic",
// // // // // //     //   description:   "Visual icons and charts for data-heavy profiles.",
// // // // // //     //   tags:          ["Data", "Analytics", "Research"],
// // // // // //     //   accent:        "#f59e0b",
// // // // // //     //   headerBg:      "#92400e",
// // // // // //     //   active:        false,
// // // // // //     //   showInLanding: false,
// // // // // //     //   comingSoon:    true,
// // // // // //     // },
// // // // // //   ],

// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   // PLANS — each plan is fully independent
// // // // // //   // resumeTemplateIds  → which templates this plan unlocks
// // // // // //   // resumeTemplateCount → how many templates user can SELECT
// // // // // //   //   (null = unlimited, 1 = pick 1, 2 = pick any 2, etc.)
// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   plans: [

// // // // // //     // ── PLAN 1: ATS Basic ──────────────────────────────────────
// // // // // //     {
// // // // // //       id:           "ats_basic",
// // // // // //       name:         "ATS Basic",
// // // // // //       price:        "$2.99",
// // // // // //       priceInCents: 299,
// // // // // //       period:       "one-time",
// // // // // //       description:  "2 ATS analyses + 1 AI-improved resume using your real data in your chosen template.",
// // // // // //       highlight:    false,
// // // // // //       badge:        null,
// // // // // //       enabled:      true,
// // // // // //       active:       true,
// // // // // //       includes: [
// // // // // //         "ATS_ANALYSIS",
// // // // // //         "ATS_RESUME_IMPROVED", // renamed from SAMPLE — now uses real resume data
// // // // // //       ],

// // // // // //       // ── Usage limits (configurable here) ──
// // // // // //       analysisCount:    2,  // how many ATS analyses allowed per purchase
// // // // // //       resumeGenCount:   1,  // how many resume generations allowed per purchase

// // // // // //       // ── Template access ──
// // // // // //       // List ONLY the template ids this plan allows.
// // // // // //       // Users see exactly these templates during resume generation.
// // // // // //       // To add/remove: edit the array below and redeploy frontend only.
// // // // // //       // Upgrade plans can have more templates (e.g. doc_pro gets all 7).
// // // // // //       resumeTemplateIds:   ["classic", "modern", "executive", "minimal", "elegant", "bold", "sidebarlight", "academic"], // 8 templates
// // // // // //       resumeTemplateCount: 1,  // user picks 1 template per generation

// // // // // //       features: [
// // // // // //         { text: "2 ATS Analyses per purchase",        included: true  },
// // // // // //         { text: "Full ATS Score (0–100)",              included: true  },
// // // // // //         { text: "Keyword Gap Analysis",                included: true  },
// // // // // //         { text: "Section-by-Section Feedback",         included: true  },
// // // // // //         { text: "AI Rewrite Suggestions",              included: true  },
// // // // // //         { text: "Downloadable Analysis Report",        included: true  },
// // // // // //         { text: "1 AI-Improved Resume (Multiple Templates)",  included: true  },
// // // // // //         { text: "Uses YOUR real resume data",          included: true  },
// // // // // //         { text: "Missing keywords auto-injected",      included: true  },
// // // // // //         { text: "Document Summary & Charts",           included: false },
// // // // // //         { text: "Document Chat / Q&A",                 included: false },
// // // // // //       ],
// // // // // //       cta:      "Get Started",
// // // // // //       ctaRoute: "/signup",
// // // // // //     },

// // // // // //     // ── PLAN 2: Document Pro ───────────────────────────────────
// // // // // //     {
// // // // // //       id:           "doc_pro",
// // // // // //       name:         "Document Pro",
// // // // // //       price:        "$2.99",
// // // // // //       priceInCents: 299,
// // // // // //       period:       "one-time",
// // // // // //       description:  "AI-powered document summary with charts and interactive Q&A chat.",
// // // // // //       highlight:    true,
// // // // // //       badge:        "Coming Soon",
// // // // // //       enabled:      true,
// // // // // //       active:       false,
// // // // // //       includes: [
// // // // // //         "DOCUMENT_SUMMARY",
// // // // // //         "DOCUMENT_CHAT",
// // // // // //         "ATS_ANALYSIS",
// // // // // //         "ATS_RESUME_SAMPLE",
// // // // // //       ],
// // // // // //       // ── Usage limits ──
// // // // // //       analysisCount:    3,  // doc_pro gets more analyses
// // // // // //       resumeGenCount:   1,

// // // // // //       // ── Template access ──
// // // // // //       // ── Template access — doc_pro gets ALL templates as upgrade incentive ──
// // // // // //       //resumeTemplateIds:   ["classic", "modern", "executive", "minimal", "corporate", "creative", "technical", "elegant", "bold", "sidebarlight", "academic"],
// // // // // //       resumeTemplateIds:   ["classic", "modern", "executive", "minimal", "corporate", "technical"],
// // // // // //       resumeTemplateCount: 1,
// // // // // //       features: [
// // // // // //         { text: "Upload Any Document (PDF, Word)",   included: true  },
// // // // // //         { text: "AI Document Summary",               included: true  },
// // // // // //         { text: "Key Points Extraction",             included: true  },
// // // // // //         { text: "Visual Charts & Insights",          included: true  },
// // // // // //         { text: "Document Chat / Q&A",               included: true  },
// // // // // //         { text: "3 ATS Resume Analyses",             included: true  },
// // // // // //         { text: "1 AI-Improved Resume (Multiple Templates)",included: true  },
// // // // // //       ],
// // // // // //       cta:      "Notify Me",
// // // // // //       ctaRoute: "/support",
// // // // // //     },

// // // // // //     // ── Future plans template ──────────────────────────────────
// // // // // //     // {
// // // // // //     //   id:           "pro_unlimited",
// // // // // //     //   name:         "Pro Unlimited",
// // // // // //     //   price:        "$9.99",
// // // // // //     //   priceInCents: 999,
// // // // // //     //   period:       "per month",
// // // // // //     //   resumeTemplateIds:   ["classic", "modern", "executive", "minimal", "creative"],
// // // // // //     //   resumeTemplateCount: null, // unlimited — user can generate with any template
// // // // // //     //   ...
// // // // // //     // },

// // // // // //   ],

// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   // SERVICES
// // // // // //   // ─────────────────────────────────────────────────────────────
// // // // // //   services: [
// // // // // //     {
// // // // // //       id:          "ats_analysis",
// // // // // //       serviceCode: "ATS_ANALYSIS",
// // // // // //       planId:      "ats_basic",
// // // // // //       isFree:      false,
// // // // // //       icon:        "🎯",
// // // // // //       title:       "ATS Resume Analysis",
// // // // // //       description: "Detailed ATS score, keyword gap analysis, section feedback and AI rewrite suggestions.",
// // // // // //       badge:       null,
// // // // // //       active:      true,
// // // // // //       enabled:     true,
// // // // // //       comingSoon:  false,
// // // // // //       highlights:  ["ATS Score 0–100", "Keyword Gap Analysis", "AI Feedback"],
// // // // // //       route:       null,
// // // // // //     },
// // // // // //     {
// // // // // //       id:          "ats_resume_sample",
// // // // // //       serviceCode: "ATS_RESUME_SAMPLE",
// // // // // //       planId:      "ats_basic",
// // // // // //       isFree:      true,
// // // // // //       icon:        "✨",
// // // // // //       title:       "Sample ATS Resume",
// // // // // //       description: "Generate a fully ATS-optimized sample resume in your chosen template.",
// // // // // //       badge:       "FREE",
// // // // // //       badgeColor:  "#3B6D11",
// // // // // //       badgeBg:     "#EAF3DE",
// // // // // //       active:      true,
// // // // // //       enabled:     true,
// // // // // //       comingSoon:  false,
// // // // // //       highlights:  ["4 Templates", "AI-Powered", "PDF + Word + HTML"],
// // // // // //       route:       "/generate-resume",
// // // // // //     },
// // // // // //     {
// // // // // //       id:          "document_summary",
// // // // // //       serviceCode: "DOCUMENT_SUMMARY",
// // // // // //       planId:      "doc_pro",
// // // // // //       isFree:      false,
// // // // // //       icon:        "📊",
// // // // // //       title:       "Document Summary",
// // // // // //       description: "Upload any document and get an AI summary with visual charts and key insights.",
// // // // // //       badge:       null,
// // // // // //       active:      false,
// // // // // //       enabled:     true,
// // // // // //       comingSoon:  true,
// // // // // //       highlights:  ["AI Summary", "Visual Charts", "Key Points"],
// // // // // //       route:       "/document-summary",
// // // // // //     },
// // // // // //     {
// // // // // //       id:          "document_chat",
// // // // // //       serviceCode: "DOCUMENT_CHAT",
// // // // // //       planId:      "doc_pro",
// // // // // //       isFree:      false,
// // // // // //       icon:        "💬",
// // // // // //       title:       "Document Chat",
// // // // // //       description: "Ask questions and have a conversation with any document using AI.",
// // // // // //       badge:       null,
// // // // // //       active:      false,
// // // // // //       enabled:     true,
// // // // // //       comingSoon:  true,
// // // // // //       highlights:  ["Ask Questions", "AI Answers", "Any Document"],
// // // // // //       route:       "/document-chat",
// // // // // //     },
// // // // // //   ],

// // // // // //   steps: [
// // // // // //     { num: "1", icon: "🎯", label: "Select Plan",              desc: "Choose the plan you need."            },
// // // // // //     { num: "2", icon: "💳", label: "Pay",                      desc: "One-time payment, no subscriptions.", priceRef: true },
// // // // // //     { num: "3", icon: "📄", label: "Upload Resume / Document", desc: "Word, PDF, or paste text."            },
// // // // // //     { num: "4", icon: "📋", label: "Paste Job Description",    desc: "Copy from any job board."             },
// // // // // //     { num: "5", icon: "🚀", label: "Get Your Results",          desc: "Download, chat, or analyze."          },
// // // // // //   ],

// // // // // //   stats: [
// // // // // //     { value: "90%+",  label: "ATS Compatibility Rate"  },
// // // // // //     { value: "$2.99", label: "Starting Price"           },
// // // // // //     { value: "60s",   label: "Average Analysis Time"    },
// // // // // //     { value: "2×",    label: "ATS Analyses Included"    },
// // // // // //   ],

// // // // // //   faq: [
// // // // // //     {
// // // // // //       q: "What is an ATS score?",
// // // // // //       a: "An ATS (Applicant Tracking System) score measures how well your resume matches a job description. Most companies use ATS software to filter resumes before a human sees them. A higher score means more chances of getting noticed.",
// // // // // //     },
// // // // // //     {
// // // // // //       q: "What does ATS Basic include?",
// // // // // //       a: "ATS Basic ($2.99) includes a full ATS resume analysis with scoring, keyword gap analysis, section feedback, AI rewrite suggestions, a downloadable report, and one free sample ATS resume generator with 4 template choices.",
// // // // // //     },
// // // // // //     {
// // // // // //       q: "How many resume templates can I use?",
// // // // // //       a: "ATS Basic includes access to multiple resume templates — Classic ATS, Modern Pro, Executive, and Minimal Clean. You select one template per generation. Each paid analysis unlocks one free resume generation.",
// // // // // //     },
// // // // // //     {
// // // // // //       q: "What does Document Pro include?",
// // // // // //       a: "Document Pro includes AI-powered document summarization with visual charts, key points extraction, and an interactive Q&A chat. Coming soon!",
// // // // // //     },
// // // // // //     {
// // // // // //       q: "Are the plans cumulative?",
// // // // // //       a: "No — each plan is independent. You pay for what you need.",
// // // // // //     },
// // // // // //     {
// // // // // //       q: "Is there a subscription?",
// // // // // //       a: "No subscriptions. Each plan is a one-time payment, only when you need it.",
// // // // // //     },
// // // // // //     {
// // // // // //       q: "What file formats are supported?",
// // // // // //       a: "Resume analysis: Word (.docx) or paste plain text. Reports download in PDF, Word, or HTML.",
// // // // // //     },
// // // // // //     {
// // // // // //       q: "Is my data secure?",
// // // // // //       a: "Yes. Your data is stored securely and never shared with third parties. Payments are processed by Stripe with bank-level encryption.",
// // // // // //     },
// // // // // //   ],

// // // // // // };

// // // // // // export default servicesConfig;

// // // // // // src/utils/servicesConfig.js
// // // // // //
// // // // // // ═══════════════════════════════════════════════════════════════
// // // // // // HOW TO CONFIGURE
// // // // // // ═══════════════════════════════════════════════════════════════
// // // // // //
// // // // // // ADD A NEW PLAN:
// // // // // //   1. Add to plans[] with unique id, price, includes[]
// // // // // //   2. Add price to backend/server.js PLAN_PRICES
// // // // // //   3. Set enabled/active: true when ready
// // // // // //
// // // // // // ADD A NEW SERVICE:
// // // // // //   1. Add to services[] with unique serviceCode
// // // // // //   2. Add serviceCode to relevant plan includes[]
// // // // // //
// // // // // // ADD A NEW RESUME TEMPLATE:
// // // // // //   1. Add to resumeTemplates[] with unique id
// // // // // //   2. Add id to relevant plan resumeTemplateIds[]
// // // // // //   3. Add rendering in ResumeGeneratorPage.jsx
// // // // // //   4. Add styling in generateResumeDoc.js
// // // // // //
// // // // // // CONTROL TEMPLATE ACCESS PER PLAN:
// // // // // //   Set resumeTemplateCount — how many templates user can choose from
// // // // // //   Set resumeTemplateIds   — which specific templates are available
// // // // // //
// // // // // // ═══════════════════════════════════════════════════════════════

// // // // // const servicesConfig = {

// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   // APP BRANDING — change here, updates everywhere automatically
// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   app: {
// // // // //     name:        "ResumeScoreAI",
// // // // //     tagline:     "Beat the ATS. Get the interview.",        // ← hero headline suffix
// // // // //     taglinePre:  "Beat the ATS.",                           // ← line 1 of split tagline
// // // // //     taglinePost: "Get the interview.",                      // ← line 2 of split tagline
// // // // //     description: "AI-powered ATS resume analysis and generation — beat the ATS, get the interview.",
// // // // //     shortDesc:   "Beat the ATS. Get the interview.",        // ← used in meta, footer
// // // // //     ctaHero:     "Analyze My Resume",                       // ← primary CTA button text
// // // // //     ctaNav:      "Get Started Free",                        // ← nav CTA for logged-out
// // // // //     ctaNavUser:  "New Analysis",                            // ← nav CTA for logged-in
// // // // //     supportHours:"48 hours",                                // ← support response time
// // // // //     domain:      "smartaicareer.com",
// // // // //     email:       "support@smartaicareer.com",
// // // // //     twitter:     "",
// // // // //     linkedin:    "",
// // // // //   },

// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   // RESUME TEMPLATES
// // // // //   // Single source of truth for all available templates.
// // // // //   // Access per plan is controlled via plan.resumeTemplateIds[]
// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   // RESUME TEMPLATES
// // // // //   //
// // // // //   // Each template has these control flags:
// // // // //   //   active:     true  → built, tested, available for use
// // // // //   //               false → disabled globally (not shown anywhere)
// // // // //   //   showInLanding: true  → shown in landing page carousel
// // // // //   //   comingSoon: true  → show greyed-out with "Coming Soon" badge
// // // // //   //
// // // // //   // Plan access is controlled via plans[].resumeTemplateIds[]
// // // // //   // To add a new template:
// // // // //   //   1. Add entry here with active: false, comingSoon: true
// // // // //   //   2. Build the renderer in TemplateMini.jsx, ResumePreview, generateResumeDoc.js
// // // // //   //   3. Set active: true when ready
// // // // //   //   4. Add id to relevant plan's resumeTemplateIds[]
// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   resumeTemplates: [
// // // // //     {
// // // // //       id:            "classic_bw",
// // // // //       name:          "Classic Black & White",
// // // // //       description:   "Pure black and white. Maximum ATS compatibility, zero color risk.",
// // // // //       tags:          ["Any Industry", "ATS Safe", "Universal"],
// // // // //       accent:        "#000000",
// // // // //       headerBg:      "#000000",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "traditional",
// // // // //       name:          "Traditional",
// // // // //       description:   "Times New Roman serif, centered header, the most recruiter-familiar layout.",
// // // // //       tags:          ["Law", "Finance", "Government"],
// // // // //       accent:        "#1a1a1a",
// // // // //       headerBg:      "#1a1a1a",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "classic",
// // // // //       name:          "Classic ATS",
// // // // //       description:   "Clean single-column layout. Best for traditional industries.",
// // // // //       tags:          ["Finance", "Law", "Healthcare"],
// // // // //       accent:        "#2563eb",
// // // // //       headerBg:      "#1e293b",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "modern",
// // // // //       name:          "Modern Pro",
// // // // //       description:   "Bold sidebar with skill bars. Great for tech roles.",
// // // // //       tags:          ["Tech", "Engineering", "Design"],
// // // // //       accent:        "#7c3aed",
// // // // //       headerBg:      "#7c3aed",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "executive",
// // // // //       name:          "Executive",
// // // // //       description:   "Dark full-width header for senior-level positions.",
// // // // //       tags:          ["Management", "C-Suite", "Director"],
// // // // //       accent:        "#0f172a",
// // // // //       headerBg:      "#0f172a",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "minimal",
// // // // //       name:          "Minimal Clean",
// // // // //       description:   "Ultra clean whitespace. Passes all ATS scanners easily.",
// // // // //       tags:          ["Any Industry", "Entry Level", "Remote"],
// // // // //       accent:        "#059669",
// // // // //       headerBg:      "#059669",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "corporate",
// // // // //       name:          "Corporate",
// // // // //       description:   "Gradient header with professional layout for business roles.",
// // // // //       tags:          ["Business", "Consulting", "Banking"],
// // // // //       accent:        "#0369a1",
// // // // //       headerBg:      "#0c4a6e",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "creative",
// // // // //       name:          "Creative",
// // // // //       description:   "Bold diagonal header with color accents for creative roles.",
// // // // //       tags:          ["Marketing", "Design", "Media"],
// // // // //       accent:        "#e11d48",
// // // // //       headerBg:      "#881337",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "technical",
// // // // //       name:          "Technical",
// // // // //       description:   "Code-style layout optimized for engineers and developers.",
// // // // //       tags:          ["Engineering", "Software", "Data Science"],
// // // // //       accent:        "#0891b2",
// // // // //       headerBg:      "#164e63",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "elegant",
// // // // //       name:          "Elegant",
// // // // //       description:   "Refined serif typography with a tasteful two-tone sidebar accent.",
// // // // //       tags:          ["Finance", "Law", "Consulting"],
// // // // //       accent:        "#b45309",
// // // // //       headerBg:      "#1c1917",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "bold",
// // // // //       name:          "Bold Impact",
// // // // //       description:   "Large name, strong section dividers. Stands out in any stack.",
// // // // //       tags:          ["Sales", "Marketing", "Operations"],
// // // // //       accent:        "#1d4ed8",
// // // // //       headerBg:      "#1e3a8a",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "sidebarlight",
// // // // //       name:          "Sidebar Light",
// // // // //       description:   "Clean light sidebar with contact info. Balanced and modern.",
// // // // //       tags:          ["Product", "Design", "HR"],
// // // // //       accent:        "#0d9488",
// // // // //       headerBg:      "#f0fdfa",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "academic",
// // // // //       name:          "Academic",
// // // // //       description:   "Formal layout for research, academia, and PhD applications.",
// // // // //       tags:          ["Research", "Academia", "Science"],
// // // // //       accent:        "#7c3aed",
// // // // //       headerBg:      "#1e1b4b",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "professional",
// // // // //       name:          "Professional",
// // // // //       description:   "Traditional two-column header, clean lines. Universal ATS compatibility.",
// // // // //       tags:          ["Finance", "Banking", "Insurance"],
// // // // //       accent:        "#1e3a5f",
// // // // //       headerBg:      "#1e3a5f",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "compact",
// // // // //       name:          "Compact",
// // // // //       description:   "Fits more content per page. Ideal for experienced professionals.",
// // // // //       tags:          ["Senior", "Management", "10+ Years"],
// // // // //       accent:        "#374151",
// // // // //       headerBg:      "#111827",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "cleanserif",
// // // // //       name:          "Clean Serif",
// // // // //       description:   "Warm serif fonts with generous spacing. Great for non-tech industries.",
// // // // //       tags:          ["Healthcare", "Education", "Nonprofit"],
// // // // //       accent:        "#7f1d1d",
// // // // //       headerBg:      "#450a0a",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     {
// // // // //       id:            "government",
// // // // //       name:          "Government",
// // // // //       description:   "Strict formatting for federal and government job applications.",
// // // // //       tags:          ["Federal", "Public Sector", "Military"],
// // // // //       accent:        "#1e3a5f",
// // // // //       headerBg:      "#0f2137",
// // // // //       active:        true,
// // // // //       showInLanding: true,
// // // // //       comingSoon:    false,
// // // // //     },
// // // // //     // ── Future templates — set active:false until renderer is built ──
// // // // //     // {
// // // // //     //   id:            "infographic",
// // // // //     //   name:          "Infographic",
// // // // //     //   description:   "Visual icons and charts for data-heavy profiles.",
// // // // //     //   tags:          ["Data", "Analytics", "Research"],
// // // // //     //   accent:        "#f59e0b",
// // // // //     //   headerBg:      "#92400e",
// // // // //     //   active:        false,
// // // // //     //   showInLanding: false,
// // // // //     //   comingSoon:    true,
// // // // //     // },
// // // // //   ],

// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   // PLANS — each plan is fully independent
// // // // //   // resumeTemplateIds  → which templates this plan unlocks
// // // // //   // resumeTemplateCount → how many templates user can SELECT
// // // // //   //   (null = unlimited, 1 = pick 1, 2 = pick any 2, etc.)
// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   plans: [

// // // // //     // ── PLAN 1: ATS Basic ──────────────────────────────────────
// // // // //     {
// // // // //       id:           "ats_basic",
// // // // //       name:         "ATS Basic",
// // // // //       price:        "$2.99",
// // // // //       priceInCents: 299,
// // // // //       period:       "one-time",
// // // // //       description:  "2 ATS analyses + 1 AI-improved resume using your real data in your chosen template.",
// // // // //       highlight:    false,
// // // // //       badge:        null,
// // // // //       enabled:      true,
// // // // //       active:       true,
// // // // //       includes: [
// // // // //         "ATS_ANALYSIS",
// // // // //         "ATS_RESUME_IMPROVED", // renamed from SAMPLE — now uses real resume data
// // // // //         "COVER_LETTER",
// // // // //       ],

// // // // //       // ── Usage limits (configurable here) ──
// // // // //       analysisCount:    2,  // how many ATS analyses allowed per purchase
// // // // //       resumeGenCount:   1,  // how many resume generations allowed per purchase
// // // // //       coverLetterCount: 1,  // 1 cover letter per purchase

// // // // //       // ── Template access ──
// // // // //       // List ONLY the template ids this plan allows.
// // // // //       // Users see exactly these templates during resume generation.
// // // // //       // To add/remove: edit the array below and redeploy frontend only.
// // // // //       // Upgrade plans can have more templates (e.g. doc_pro gets all 7).
// // // // //       resumeTemplateIds:   ["classic_bw","tradional","classic", "modern", "executive", "minimal", "elegant", "bold", "sidebarlight", "academic", "professional", "compact", "cleanserif", "government"], // 12 templates
// // // // //       resumeTemplateCount: 1,  // user picks 1 template per generation

// // // // //       features: [
// // // // //         { text: "2 ATS Analyses per purchase",        included: true  },
// // // // //         { text: "Full ATS Score (0–100)",              included: true  },
// // // // //         { text: "Keyword Gap Analysis",                included: true  },
// // // // //         { text: "Section-by-Section Feedback",         included: true  },
// // // // //         { text: "AI Rewrite Suggestions",              included: true  },
// // // // //         { text: "Downloadable Analysis Report",        included: true  },
// // // // //         { text: "1 AI-Improved Resume (Multiple Templates)",  included: true  },
// // // // //         { text: "Uses YOUR real resume data",          included: true  },
// // // // //         { text: "Missing keywords auto-injected",      included: true  },
// // // // //         { text: "Document Summary & Charts",           included: false },
// // // // //         { text: "Document Chat / Q&A",                 included: false },
// // // // //       ],
// // // // //       cta:      "Get Started",
// // // // //       ctaRoute: "/signup",
// // // // //     },

// // // // //     // ── PLAN 2: Document Pro ───────────────────────────────────
// // // // //     {
// // // // //       id:           "doc_pro",
// // // // //       name:         "Document Pro",
// // // // //       price:        "$2.99",
// // // // //       priceInCents: 299,
// // // // //       period:       "one-time",
// // // // //       description:  "AI-powered document summary with charts and interactive Q&A chat.",
// // // // //       highlight:    true,
// // // // //       badge:        "Coming Soon",
// // // // //       enabled:      true,
// // // // //       active:       false,
// // // // //       includes: [
// // // // //         "DOCUMENT_SUMMARY",
// // // // //         "DOCUMENT_CHAT",
// // // // //         "ATS_ANALYSIS",
// // // // //         "ATS_RESUME_SAMPLE",
// // // // //       ],
// // // // //       // ── Usage limits ──
// // // // //       analysisCount:    3,  // doc_pro gets more analyses
// // // // //       resumeGenCount:   1,

// // // // //       // ── Template access ──
// // // // //       // ── Template access — doc_pro gets ALL templates as upgrade incentive ──
// // // // //       resumeTemplateIds:   ["classic_bw", "traditional","classic", "modern", "executive", "minimal", "corporate", "creative", "technical", "elegant", "bold", "sidebarlight", "academic", "professional", "compact", "cleanserif", "government"],
// // // // //       resumeTemplateCount: 1,
// // // // //       features: [
// // // // //         { text: "Upload Any Document (PDF, Word)",   included: true  },
// // // // //         { text: "AI Document Summary",               included: true  },
// // // // //         { text: "Key Points Extraction",             included: true  },
// // // // //         { text: "Visual Charts & Insights",          included: true  },
// // // // //         { text: "Document Chat / Q&A",               included: true  },
// // // // //         { text: "3 ATS Resume Analyses",             included: true  },
// // // // //         { text: "1 AI-Improved Resume (Multiple Templates)",included: true  },
// // // // //       ],
// // // // //       cta:      "Notify Me",
// // // // //       ctaRoute: "/support",
// // // // //     },

// // // // //     // ── Future plans template ──────────────────────────────────
// // // // //     // {
// // // // //     //   id:           "pro_unlimited",
// // // // //     //   name:         "Pro Unlimited",
// // // // //     //   price:        "$9.99",
// // // // //     //   priceInCents: 999,
// // // // //     //   period:       "per month",
// // // // //     //   resumeTemplateIds:   ["classic", "modern", "executive", "minimal", "creative"],
// // // // //     //   resumeTemplateCount: null, // unlimited — user can generate with any template
// // // // //     //   ...
// // // // //     // },

// // // // //   ],

// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   // SERVICES
// // // // //   // ─────────────────────────────────────────────────────────────
// // // // //   services: [
// // // // //     {
// // // // //       id:          "ats_analysis",
// // // // //       serviceCode: "ATS_ANALYSIS",
// // // // //       planId:      "ats_basic",
// // // // //       isFree:      false,
// // // // //       icon:        "🎯",
// // // // //       title:       "ATS Resume Analysis",
// // // // //       description: "Detailed ATS score, keyword gap analysis, section feedback and AI rewrite suggestions.",
// // // // //       badge:       null,
// // // // //       active:      true,
// // // // //       enabled:     true,
// // // // //       comingSoon:  false,
// // // // //       highlights:  ["ATS Score 0–100", "Keyword Gap Analysis", "AI Feedback"],
// // // // //       route:       null,
// // // // //     },
// // // // //     {
// // // // //       id:          "ats_resume_sample",
// // // // //       serviceCode: "ATS_RESUME_SAMPLE",
// // // // //       planId:      "ats_basic",
// // // // //       isFree:      true,
// // // // //       icon:        "✨",
// // // // //       title:       "Sample ATS Resume",
// // // // //       description: "Generate a fully ATS-optimized sample resume in your chosen template.",
// // // // //       badge:       "FREE",
// // // // //       badgeColor:  "#3B6D11",
// // // // //       badgeBg:     "#EAF3DE",
// // // // //       active:      true,
// // // // //       enabled:     true,
// // // // //       comingSoon:  false,
// // // // //       highlights:  ["4 Templates", "AI-Powered", "PDF + Word + HTML"],
// // // // //       route:       "/generate-resume",
// // // // //     },
// // // // //     {
// // // // //       id:          "document_summary",
// // // // //       serviceCode: "DOCUMENT_SUMMARY",
// // // // //       planId:      "doc_pro",
// // // // //       isFree:      false,
// // // // //       icon:        "📊",
// // // // //       title:       "Document Summary",
// // // // //       description: "Upload any document and get an AI summary with visual charts and key insights.",
// // // // //       badge:       null,
// // // // //       active:      false,
// // // // //       enabled:     true,
// // // // //       comingSoon:  true,
// // // // //       highlights:  ["AI Summary", "Visual Charts", "Key Points"],
// // // // //       route:       "/document-summary",
// // // // //     },
// // // // //     {
// // // // //       id:          "document_chat",
// // // // //       serviceCode: "DOCUMENT_CHAT",
// // // // //       planId:      "doc_pro",
// // // // //       isFree:      false,
// // // // //       icon:        "💬",
// // // // //       title:       "Document Chat",
// // // // //       description: "Ask questions and have a conversation with any document using AI.",
// // // // //       badge:       null,
// // // // //       active:      false,
// // // // //       enabled:     true,
// // // // //       comingSoon:  true,
// // // // //       highlights:  ["Ask Questions", "AI Answers", "Any Document"],
// // // // //       route:       "/document-chat",
// // // // //     },
// // // // //     {
// // // // //       id:          "cover_letter",
// // // // //       serviceCode: "COVER_LETTER",
// // // // //       planId:      "ats_basic",
// // // // //       isFree:      false,
// // // // //       icon:        "✉️",
// // // // //       title:       "AI Cover Letter",
// // // // //       description: "Generate a tailored cover letter using your resume and job description.",
// // // // //       badge:       null,
// // // // //       active:      true,
// // // // //       enabled:     true,
// // // // //       comingSoon:  false,
// // // // //       highlights:  ["Tailored to JD", "Professional Tone", "PDF + Word"],
// // // // //       route:       "/cover-letter",
// // // // //     },
// // // // //   ],

// // // // //   steps: [
// // // // //     { num: "1", icon: "🎯", label: "Select Plan",              desc: "Choose the plan you need."            },
// // // // //     { num: "2", icon: "💳", label: "Pay",                      desc: "One-time payment, no subscriptions.", priceRef: true },
// // // // //     { num: "3", icon: "📄", label: "Upload Resume / Document", desc: "Word, PDF, or paste text."            },
// // // // //     { num: "4", icon: "📋", label: "Paste Job Description",    desc: "Copy from any job board."             },
// // // // //     { num: "5", icon: "🚀", label: "Get Your Results",          desc: "Download, chat, or analyze."          },
// // // // //   ],

// // // // //   stats: [
// // // // //     { value: "90%+",  label: "ATS Compatibility Rate"  },
// // // // //     { value: "$2.99", label: "Starting Price"           },
// // // // //     { value: "60s",   label: "Average Analysis Time"    },
// // // // //     { value: "2×",    label: "ATS Analyses Included"    },
// // // // //   ],

// // // // //   faq: [
// // // // //     {
// // // // //       q: "What is an ATS score?",
// // // // //       a: "An ATS (Applicant Tracking System) score measures how well your resume matches a job description. Most companies use ATS software to filter resumes before a human sees them. A higher score means more chances of getting noticed.",
// // // // //     },
// // // // //     {
// // // // //       q: "What does ATS Basic include?",
// // // // //       a: "ATS Basic ($1.99) includes a full ATS resume analysis with scoring, keyword gap analysis, section feedback, AI rewrite suggestions, a downloadable report, and one free sample ATS resume generator with 4 template choices.",
// // // // //     },
// // // // //     {
// // // // //       q: "How many resume templates can I use?",
// // // // //       a: "ATS Basic includes access to all 4 resume templates — Classic ATS, Modern Pro, Executive, and Minimal Clean. You select one template per generation. Each paid analysis unlocks one free resume generation.",
// // // // //     },
// // // // //     {
// // // // //       q: "What does Document Pro include?",
// // // // //       a: "Document Pro includes AI-powered document summarization with visual charts, key points extraction, and an interactive Q&A chat. Coming soon!",
// // // // //     },
// // // // //     {
// // // // //       q: "Are the plans cumulative?",
// // // // //       a: "No — each plan is independent. You pay for what you need.",
// // // // //     },
// // // // //     {
// // // // //       q: "Is there a subscription?",
// // // // //       a: "No subscriptions. Each plan is a one-time payment, only when you need it.",
// // // // //     },
// // // // //     {
// // // // //       q: "What file formats are supported?",
// // // // //       a: "Resume analysis: Word (.docx) or paste plain text. Reports download in PDF, Word, or HTML.",
// // // // //     },
// // // // //     {
// // // // //       q: "Is my data secure?",
// // // // //       a: "Yes. Your data is stored securely and never shared with third parties. Payments are processed by Stripe with bank-level encryption.",
// // // // //     },
// // // // //   ],

// // // // // };

// // // // // export default servicesConfig;

// // // // // src/utils/servicesConfig.js
// // // // //
// // // // // ═══════════════════════════════════════════════════════════════
// // // // // HOW TO CONFIGURE
// // // // // ═══════════════════════════════════════════════════════════════
// // // // //
// // // // // ADD A NEW PLAN:
// // // // //   1. Add to plans[] with unique id, price, includes[]
// // // // //   2. Add price to backend/server.js PLAN_PRICES
// // // // //   3. Set enabled/active: true when ready
// // // // //
// // // // // ADD A NEW SERVICE:
// // // // //   1. Add to services[] with unique serviceCode
// // // // //   2. Add serviceCode to relevant plan includes[]
// // // // //
// // // // // ADD A NEW RESUME TEMPLATE:
// // // // //   1. Add to resumeTemplates[] with unique id
// // // // //   2. Add id to relevant plan resumeTemplateIds[]
// // // // //   3. Add rendering in ResumeGeneratorPage.jsx
// // // // //   4. Add styling in generateResumeDoc.js
// // // // //
// // // // // CONTROL TEMPLATE ACCESS PER PLAN:
// // // // //   Set resumeTemplateCount — how many templates user can choose from
// // // // //   Set resumeTemplateIds   — which specific templates are available
// // // // //
// // // // // ═══════════════════════════════════════════════════════════════

// // // // const servicesConfig = {

// // // //   // ─────────────────────────────────────────────────────────────
// // // //   // APP BRANDING — change here, updates everywhere automatically
// // // //   // ─────────────────────────────────────────────────────────────
// // // //   app: {
// // // //     name:        "ResumeScoreAI",
// // // //     tagline:     "Beat the ATS. Get the interview.",        // ← hero headline suffix
// // // //     taglinePre:  "Beat the ATS.",                           // ← line 1 of split tagline
// // // //     taglinePost: "Get the interview.",                      // ← line 2 of split tagline
// // // //     description: "AI-powered ATS resume analysis and generation — beat the ATS, get the interview.",
// // // //     shortDesc:   "Beat the ATS. Get the interview.",        // ← used in meta, footer
// // // //     ctaHero:     "Analyze My Resume",                       // ← primary CTA button text
// // // //     ctaNav:      "Get Started Free",                        // ← nav CTA for logged-out
// // // //     ctaNavUser:  "New Analysis",                            // ← nav CTA for logged-in
// // // //     supportHours:"48 hours",                                // ← support response time
// // // //     domain:      "smartaicareer.com",
// // // //     email:       "support@smartaicareer.com",
// // // //     twitter:     "",
// // // //     linkedin:    "",
// // // //   },

// // // //   // ─────────────────────────────────────────────────────────────
// // // //   // RESUME TEMPLATES
// // // //   // Single source of truth for all available templates.
// // // //   // Access per plan is controlled via plan.resumeTemplateIds[]
// // // //   // ─────────────────────────────────────────────────────────────
// // // //   // ─────────────────────────────────────────────────────────────
// // // //   // RESUME TEMPLATES
// // // //   //
// // // //   // Each template has these control flags:
// // // //   //   active:     true  → built, tested, available for use
// // // //   //               false → disabled globally (not shown anywhere)
// // // //   //   showInLanding: true  → shown in landing page carousel
// // // //   //   comingSoon: true  → show greyed-out with "Coming Soon" badge
// // // //   //
// // // //   // Plan access is controlled via plans[].resumeTemplateIds[]
// // // //   // To add a new template:
// // // //   //   1. Add entry here with active: false, comingSoon: true
// // // //   //   2. Build the renderer in TemplateMini.jsx, ResumePreview, generateResumeDoc.js
// // // //   //   3. Set active: true when ready
// // // //   //   4. Add id to relevant plan's resumeTemplateIds[]
// // // //   // ─────────────────────────────────────────────────────────────
// // // //   resumeTemplates: [
// // // //     {
// // // //       id:            "classic_bw",
// // // //       name:          "Classic Black & White",
// // // //       description:   "Pure black and white. Maximum ATS compatibility, zero color risk.",
// // // //       tags:          ["Any Industry", "ATS Safe", "Universal"],
// // // //       accent:        "#000000",
// // // //       headerBg:      "#000000",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "traditional",
// // // //       name:          "Traditional",
// // // //       description:   "Times New Roman serif, centered header, the most recruiter-familiar layout.",
// // // //       tags:          ["Law", "Finance", "Government"],
// // // //       accent:        "#1a1a1a",
// // // //       headerBg:      "#1a1a1a",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "classic",
// // // //       name:          "Classic ATS",
// // // //       description:   "Clean single-column layout. Best for traditional industries.",
// // // //       tags:          ["Finance", "Law", "Healthcare"],
// // // //       accent:        "#2563eb",
// // // //       headerBg:      "#1e293b",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "modern",
// // // //       name:          "Modern Pro",
// // // //       description:   "Bold sidebar with skill bars. Great for tech roles.",
// // // //       tags:          ["Tech", "Engineering", "Design"],
// // // //       accent:        "#7c3aed",
// // // //       headerBg:      "#7c3aed",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "executive",
// // // //       name:          "Executive",
// // // //       description:   "Dark full-width header for senior-level positions.",
// // // //       tags:          ["Management", "C-Suite", "Director"],
// // // //       accent:        "#0f172a",
// // // //       headerBg:      "#0f172a",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "minimal",
// // // //       name:          "Minimal Clean",
// // // //       description:   "Ultra clean whitespace. Passes all ATS scanners easily.",
// // // //       tags:          ["Any Industry", "Entry Level", "Remote"],
// // // //       accent:        "#059669",
// // // //       headerBg:      "#059669",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "corporate",
// // // //       name:          "Corporate",
// // // //       description:   "Gradient header with professional layout for business roles.",
// // // //       tags:          ["Business", "Consulting", "Banking"],
// // // //       accent:        "#0369a1",
// // // //       headerBg:      "#0c4a6e",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "creative",
// // // //       name:          "Creative",
// // // //       description:   "Bold diagonal header with color accents for creative roles.",
// // // //       tags:          ["Marketing", "Design", "Media"],
// // // //       accent:        "#e11d48",
// // // //       headerBg:      "#881337",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "technical",
// // // //       name:          "Technical",
// // // //       description:   "Code-style layout optimized for engineers and developers.",
// // // //       tags:          ["Engineering", "Software", "Data Science"],
// // // //       accent:        "#0891b2",
// // // //       headerBg:      "#164e63",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "elegant",
// // // //       name:          "Elegant",
// // // //       description:   "Refined serif typography with a tasteful two-tone sidebar accent.",
// // // //       tags:          ["Finance", "Law", "Consulting"],
// // // //       accent:        "#b45309",
// // // //       headerBg:      "#1c1917",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "bold",
// // // //       name:          "Bold Impact",
// // // //       description:   "Large name, strong section dividers. Stands out in any stack.",
// // // //       tags:          ["Sales", "Marketing", "Operations"],
// // // //       accent:        "#1d4ed8",
// // // //       headerBg:      "#1e3a8a",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "sidebarlight",
// // // //       name:          "Sidebar Light",
// // // //       description:   "Clean light sidebar with contact info. Balanced and modern.",
// // // //       tags:          ["Product", "Design", "HR"],
// // // //       accent:        "#0d9488",
// // // //       headerBg:      "#f0fdfa",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "academic",
// // // //       name:          "Academic",
// // // //       description:   "Formal layout for research, academia, and PhD applications.",
// // // //       tags:          ["Research", "Academia", "Science"],
// // // //       accent:        "#7c3aed",
// // // //       headerBg:      "#1e1b4b",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "professional",
// // // //       name:          "Professional",
// // // //       description:   "Traditional two-column header, clean lines. Universal ATS compatibility.",
// // // //       tags:          ["Finance", "Banking", "Insurance"],
// // // //       accent:        "#1e3a5f",
// // // //       headerBg:      "#1e3a5f",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "compact",
// // // //       name:          "Compact",
// // // //       description:   "Fits more content per page. Ideal for experienced professionals.",
// // // //       tags:          ["Senior", "Management", "10+ Years"],
// // // //       accent:        "#374151",
// // // //       headerBg:      "#111827",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "cleanserif",
// // // //       name:          "Clean Serif",
// // // //       description:   "Warm serif fonts with generous spacing. Great for non-tech industries.",
// // // //       tags:          ["Healthcare", "Education", "Nonprofit"],
// // // //       accent:        "#7f1d1d",
// // // //       headerBg:      "#450a0a",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     {
// // // //       id:            "government",
// // // //       name:          "Government",
// // // //       description:   "Strict formatting for federal and government job applications.",
// // // //       tags:          ["Federal", "Public Sector", "Military"],
// // // //       accent:        "#1e3a5f",
// // // //       headerBg:      "#0f2137",
// // // //       active:        true,
// // // //       showInLanding: true,
// // // //       comingSoon:    false,
// // // //     },
// // // //     // ── Future templates — set active:false until renderer is built ──
// // // //     // {
// // // //     //   id:            "infographic",
// // // //     //   name:          "Infographic",
// // // //     //   description:   "Visual icons and charts for data-heavy profiles.",
// // // //     //   tags:          ["Data", "Analytics", "Research"],
// // // //     //   accent:        "#f59e0b",
// // // //     //   headerBg:      "#92400e",
// // // //     //   active:        false,
// // // //     //   showInLanding: false,
// // // //     //   comingSoon:    true,
// // // //     // },
// // // //   ],

// // // //   // ─────────────────────────────────────────────────────────────
// // // //   // PLANS — each plan is fully independent
// // // //   // resumeTemplateIds  → which templates this plan unlocks
// // // //   // resumeTemplateCount → how many templates user can SELECT
// // // //   //   (null = unlimited, 1 = pick 1, 2 = pick any 2, etc.)
// // // //   // ─────────────────────────────────────────────────────────────
// // // //   plans: [

// // // //     // ── PLAN 1: ATS Basic ──────────────────────────────────────
// // // //     {
// // // //       id:           "ats_basic",
// // // //       name:         "ATS Basic",
// // // //       price:        "$2.99",
// // // //       priceInCents: 299,
// // // //       period:       "one-time",
// // // //       description:  "2 ATS analyses + 1 AI-improved resume using your real data in your chosen template.",
// // // //       highlight:    false,
// // // //       badge:        null,
// // // //       enabled:      true,
// // // //       active:       true,
// // // //       includes: [
// // // //         "ATS_ANALYSIS",
// // // //         "ATS_RESUME_IMPROVED", // renamed from SAMPLE — now uses real resume data
// // // //       ],

// // // //       // ── Usage limits (configurable here) ──
// // // //       analysisCount:    2,  // how many ATS analyses allowed per purchase
// // // //       resumeGenCount:   1,  // how many resume generations allowed per purchase
// // // //       coverLetterCount: 1,  // how many cover letters allowed per purchase

// // // //       // ── Template access ──
// // // //       // List ONLY the template ids this plan allows.
// // // //       // Users see exactly these templates during resume generation.
// // // //       // To add/remove: edit the array below and redeploy frontend only.
// // // //       // Upgrade plans can have more templates (e.g. doc_pro gets all 7).
// // // //       // resumeTemplateIds:   ["classic_bw","traditional","classic", "modern", "executive", "minimal", "elegant", "bold", "sidebarlight", "academic", "professional", "compact", "cleanserif", "government"], // 12 templates
// // // //       resumeTemplateIds:   ["classic_bw","traditional","classic", "executive", "minimal", "elegant", "bold", "academic", "professional", "compact", "cleanserif", "government"], // 12 templates
// // // //       resumeTemplateCount: 1,  // user picks 1 template per generation

// // // //       features: [
// // // //         { text: "2 ATS Analyses per purchase",        included: true  },
// // // //         { text: "Full ATS Score (0–100)",              included: true  },
// // // //         { text: "Keyword Gap Analysis",                included: true  },
// // // //         { text: "Section-by-Section Feedback",         included: true  },
// // // //         { text: "AI Rewrite Suggestions",              included: true  },
// // // //         { text: "Downloadable Analysis Report",        included: true  },
// // // //         { text: "1 AI-Improved Resume (Multiple Templates)",  included: true  },
// // // //         { text: "Uses YOUR real resume data",          included: true  },
// // // //         { text: "Missing keywords auto-injected",      included: true  },
// // // //         { text: "Document Summary & Charts",           included: false },
// // // //         { text: "Document Chat / Q&A",                 included: false },
// // // //       ],
// // // //       cta:      "Get Started",
// // // //       ctaRoute: "/signup",
// // // //     },

// // // //     // ── PLAN 2: Document Pro ───────────────────────────────────
// // // //     {
// // // //       id:           "doc_pro",
// // // //       name:         "Document Pro",
// // // //       price:        "$2.99",
// // // //       priceInCents: 299,
// // // //       period:       "one-time",
// // // //       description:  "AI-powered document summary with charts and interactive Q&A chat.",
// // // //       highlight:    true,
// // // //       badge:        "Coming Soon",
// // // //       enabled:      true,
// // // //       active:       false,
// // // //       includes: [
// // // //         "DOCUMENT_SUMMARY",
// // // //         "DOCUMENT_CHAT",
// // // //         "ATS_ANALYSIS",
// // // //         "ATS_RESUME_SAMPLE",
// // // //       ],
// // // //       // ── Usage limits ──
// // // //       analysisCount:    3,  // doc_pro gets more analyses
// // // //       resumeGenCount:   1,

// // // //       // ── Template access ──
// // // //       // ── Template access — doc_pro gets ALL templates as upgrade incentive ──
// // // //       resumeTemplateIds:   ["classic", "modern", "executive", "minimal", "corporate", "creative", "technical", "elegant", "bold", "sidebarlight", "academic", "professional", "compact", "cleanserif", "government"],
// // // //       resumeTemplateCount: 1,
// // // //       features: [
// // // //         { text: "Upload Any Document (PDF, Word)",   included: true  },
// // // //         { text: "AI Document Summary",               included: true  },
// // // //         { text: "Key Points Extraction",             included: true  },
// // // //         { text: "Visual Charts & Insights",          included: true  },
// // // //         { text: "Document Chat / Q&A",               included: true  },
// // // //         { text: "3 ATS Resume Analyses",             included: true  },
// // // //         { text: "1 AI-Improved Resume (Multiple Templates)",included: true  },
// // // //       ],
// // // //       cta:      "Notify Me",
// // // //       ctaRoute: "/support",
// // // //     },

// // // //     // ── Future plans template ──────────────────────────────────
// // // //     // {
// // // //     //   id:           "pro_unlimited",
// // // //     //   name:         "Pro Unlimited",
// // // //     //   price:        "$9.99",
// // // //     //   priceInCents: 999,
// // // //     //   period:       "per month",
// // // //     //   resumeTemplateIds:   ["classic", "modern", "executive", "minimal", "creative"],
// // // //     //   resumeTemplateCount: null, // unlimited — user can generate with any template
// // // //     //   ...
// // // //     // },

// // // //   ],

// // // //   // ─────────────────────────────────────────────────────────────
// // // //   // SERVICES
// // // //   // ─────────────────────────────────────────────────────────────
// // // //   services: [
// // // //     {
// // // //       id:          "ats_analysis",
// // // //       serviceCode: "ATS_ANALYSIS",
// // // //       planId:      "ats_basic",
// // // //       isFree:      false,
// // // //       icon:        "🎯",
// // // //       title:       "ATS Resume Analysis",
// // // //       description: "Detailed ATS score, keyword gap analysis, section feedback and AI rewrite suggestions.",
// // // //       badge:       null,
// // // //       active:      true,
// // // //       enabled:     true,
// // // //       comingSoon:  false,
// // // //       highlights:  ["ATS Score 0–100", "Keyword Gap Analysis", "AI Feedback"],
// // // //       route:       null,
// // // //     },
// // // //     {
// // // //       id:          "ats_resume_sample",
// // // //       serviceCode: "ATS_RESUME_SAMPLE",
// // // //       planId:      "ats_basic",
// // // //       isFree:      true,
// // // //       icon:        "✨",
// // // //       title:       "Sample ATS Resume",
// // // //       description: "Generate a fully ATS-optimized sample resume in your chosen template.",
// // // //       badge:       "FREE",
// // // //       badgeColor:  "#3B6D11",
// // // //       badgeBg:     "#EAF3DE",
// // // //       active:      true,
// // // //       enabled:     true,
// // // //       comingSoon:  false,
// // // //       highlights:  ["4 Templates", "AI-Powered", "PDF + Word + HTML"],
// // // //       route:       "/generate-resume",
// // // //     },
// // // //     {
// // // //       id:          "document_summary",
// // // //       serviceCode: "DOCUMENT_SUMMARY",
// // // //       planId:      "doc_pro",
// // // //       isFree:      false,
// // // //       icon:        "📊",
// // // //       title:       "Document Summary",
// // // //       description: "Upload any document and get an AI summary with visual charts and key insights.",
// // // //       badge:       null,
// // // //       active:      false,
// // // //       enabled:     true,
// // // //       comingSoon:  true,
// // // //       highlights:  ["AI Summary", "Visual Charts", "Key Points"],
// // // //       route:       "/document-summary",
// // // //     },
// // // //     {
// // // //       id:          "document_chat",
// // // //       serviceCode: "DOCUMENT_CHAT",
// // // //       planId:      "doc_pro",
// // // //       isFree:      false,
// // // //       icon:        "💬",
// // // //       title:       "Document Chat",
// // // //       description: "Ask questions and have a conversation with any document using AI.",
// // // //       badge:       null,
// // // //       active:      false,
// // // //       enabled:     true,
// // // //       comingSoon:  true,
// // // //       highlights:  ["Ask Questions", "AI Answers", "Any Document"],
// // // //       route:       "/document-chat",
// // // //     },
// // // //   ],

// // // //   steps: [
// // // //     { num: "1", icon: "🎯", label: "Select Plan",              desc: "Choose the plan you need."            },
// // // //     { num: "2", icon: "💳", label: "Pay",                      desc: "One-time payment, no subscriptions.", priceRef: true },
// // // //     { num: "3", icon: "📄", label: "Upload Resume / Document", desc: "Word, PDF, or paste text."            },
// // // //     { num: "4", icon: "📋", label: "Paste Job Description",    desc: "Copy from any job board."             },
// // // //     { num: "5", icon: "🚀", label: "Get Your Results",          desc: "Download, chat, or analyze."          },
// // // //   ],

// // // //   stats: [
// // // //     { value: "90%+",  label: "ATS Compatibility Rate"  },
// // // //     { value: "$2.99", label: "Starting Price"           },
// // // //     { value: "60s",   label: "Average Analysis Time"    },
// // // //     { value: "2×",    label: "ATS Analyses Included"    },
// // // //   ],

// // // //   faq: [
// // // //     {
// // // //       q: "What is an ATS score?",
// // // //       a: "An ATS (Applicant Tracking System) score measures how well your resume matches a job description. Most companies use ATS software to filter resumes before a human sees them. A higher score means more chances of getting noticed.",
// // // //     },
// // // //     {
// // // //       q: "What does ATS Basic include?",
// // // //       a: "ATS Basic ($1.99) includes a full ATS resume analysis with scoring, keyword gap analysis, section feedback, AI rewrite suggestions, a downloadable report, and one free sample ATS resume generator with 4 template choices.",
// // // //     },
// // // //     {
// // // //       q: "How many resume templates can I use?",
// // // //       a: "ATS Basic includes access to all 4 resume templates — Classic ATS, Modern Pro, Executive, and Minimal Clean. You select one template per generation. Each paid analysis unlocks one free resume generation.",
// // // //     },
// // // //     {
// // // //       q: "What does Document Pro include?",
// // // //       a: "Document Pro includes AI-powered document summarization with visual charts, key points extraction, and an interactive Q&A chat. Coming soon!",
// // // //     },
// // // //     {
// // // //       q: "Are the plans cumulative?",
// // // //       a: "No — each plan is independent. You pay for what you need.",
// // // //     },
// // // //     {
// // // //       q: "Is there a subscription?",
// // // //       a: "No subscriptions. Each plan is a one-time payment, only when you need it.",
// // // //     },
// // // //     {
// // // //       q: "What file formats are supported?",
// // // //       a: "Resume analysis: Word (.docx) or paste plain text. Reports download in PDF, Word, or HTML.",
// // // //     },
// // // //     {
// // // //       q: "Is my data secure?",
// // // //       a: "Yes. Your data is stored securely and never shared with third parties. Payments are processed by Stripe with bank-level encryption.",
// // // //     },
// // // //   ],

// // // // };

// // // // export default servicesConfig;

// // // //--new code below
// // // // src/utils/servicesConfig.js

// // // const servicesConfig = {

// // //     // ─────────────────────────────────────────────────────────────
// // //   // APP BRANDING — change here, updates everywhere automatically
// // //   // ─────────────────────────────────────────────────────────────
// // //   app: {
// // //     name:        "ResumeScoreAI",
// // //     tagline:     "Beat the ATS. Get the interview.",        // ← hero headline suffix
// // //     taglinePre:  "Beat the ATS.",                           // ← line 1 of split tagline
// // //     taglinePost: "Get the interview.",                      // ← line 2 of split tagline
// // //     description: "AI-powered ATS resume analysis and generation — beat the ATS, get the interview.",
// // //     shortDesc:   "Beat the ATS. Get the interview.",        // ← used in meta, footer
// // //     ctaHero:     "Analyze My Resume",                       // ← primary CTA button text
// // //     ctaNav:      "Get Started Free",                        // ← nav CTA for logged-out
// // //     ctaNavUser:  "New Analysis",                            // ← nav CTA for logged-in
// // //     supportHours:"48 hours",                                // ← support response time
// // //     domain:      "smartaicareer.com",
// // //     email:       "support@smartaicareer.com",
// // //     twitter:     "",
// // //     linkedin:    "",
// // //   },

// // //   // ─────────────────────────────────────────────────────────────
// // //   // RESUME TEMPLATES — match the renderer in TemplateMini.jsx
// // //   // ─────────────────────────────────────────────────────────────
// // //   resumeTemplates: [
// // //     // === CLASSIC / TRADITIONAL ===
// // //     {
// // //       id:            "classic_bw",
// // //       name:          "Classic Black & White",
// // //       description:   "Pure black and white. Maximum ATS compatibility, zero color risk.",
// // //       tags:          ["Any Industry", "ATS Safe", "Universal"],
// // //       accent:        "#000000",
// // //       headerBg:      "#000000",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "classic",
// // //     },
// // //     {
// // //       id:            "traditional",
// // //       name:          "Traditional",
// // //       description:   "Times New Roman serif, centered header, the most recruiter-familiar layout.",
// // //       tags:          ["Law", "Finance", "Government"],
// // //       accent:        "#1a1a1a",
// // //       headerBg:      "#1a1a1a",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "classic",
// // //     },
// // //     {
// // //       id:            "classic",
// // //       name:          "Classic ATS",
// // //       description:   "Clean single-column layout. Best for traditional industries.",
// // //       tags:          ["Finance", "Law", "Healthcare"],
// // //       accent:        "#2563eb",
// // //       headerBg:      "#1e293b",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "classic",
// // //     },
// // //     {
// // //       id:            "elevated_classic",
// // //       name:          "Elevated Classic",
// // //       description:   "Traditional serif layout with modern typography and subtle elegance.",
// // //       tags:          ["Executive", "Finance", "Law"],
// // //       accent:        "#0369a1",
// // //       headerBg:      "#0c4a6e",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "classic",
// // //     },
// // //     {
// // //       id:            "cleanserif",
// // //       name:          "Clean Serif",
// // //       description:   "Warm serif fonts with generous spacing. Great for non-tech industries.",
// // //       tags:          ["Healthcare", "Education", "Nonprofit"],
// // //       accent:        "#7f1d1d",
// // //       headerBg:      "#450a0a",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "serif",
// // //     },

// // //     // === MODERN / PROFESSIONAL ===
// // //     {
// // //       id:            "modern",
// // //       name:          "Modern Pro",
// // //       description:   "Bold sidebar with skill bars. Great for tech roles.",
// // //       tags:          ["Tech", "Engineering", "Design"],
// // //       accent:        "#7c3aed",
// // //       headerBg:      "#7c3aed",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "modern",
// // //     },
// // //     {
// // //       id:            "horizontal",
// // //       name:          "Horizontal Header",
// // //       description:   "Clean design with colored horizontal header bar. Modern and professional.",
// // //       tags:          ["Tech", "Marketing", "Creative"],
// // //       accent:        "#2563eb",
// // //       headerBg:      "#ffffff",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "modern",
// // //     },
// // //     {
// // //       id:            "dual_accent",
// // //       name:          "Dual Accent",
// // //       description:   "Two-color gradient header for sophisticated visual hierarchy.",
// // //       tags:          ["Executive", "Management", "Leadership"],
// // //       accent:        "#2563eb",
// // //       headerBg:      "#ffffff",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "modern",
// // //     },
// // //     {
// // //       id:            "spaced_clean",
// // //       name:          "Spaced Clean",
// // //       description:   "Maximum readability with generous white space and clear hierarchy.",
// // //       tags:          ["Any Industry", "Creative", "Design"],
// // //       accent:        "#4f46e5",
// // //       headerBg:      "#eef2ff",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "modern",
// // //     },

// // //     // === EXECUTIVE / LEADERSHIP ===
// // //     {
// // //       id:            "executive",
// // //       name:          "Executive",
// // //       description:   "Dark full-width header for senior-level positions.",
// // //       tags:          ["Management", "C-Suite", "Director"],
// // //       accent:        "#0f172a",
// // //       headerBg:      "#0f172a",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "executive",
// // //     },
// // //     {
// // //       id:            "bold",
// // //       name:          "Bold Impact",
// // //       description:   "Large name, strong section dividers. Stands out in any stack.",
// // //       tags:          ["Sales", "Marketing", "Operations"],
// // //       accent:        "#1d4ed8",
// // //       headerBg:      "#1e3a8a",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "executive",
// // //     },
// // //     {
// // //       id:            "professional",
// // //       name:          "Professional",
// // //       description:   "Traditional two-column header, clean lines. Universal ATS compatibility.",
// // //       tags:          ["Finance", "Banking", "Insurance"],
// // //       accent:        "#1e3a5f",
// // //       headerBg:      "#1e3a5f",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "executive",
// // //     },
// // //     {
// // //       id:            "focused",
// // //       name:          "Focused",
// // //       description:   "Bold single-column layout with strong typographic hierarchy.",
// // //       tags:          ["Management", "Leadership", "Executive"],
// // //       accent:        "#dc2626",
// // //       headerBg:      "#fef2f2",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "executive",
// // //     },

// // //     // === CLEAN / MINIMAL ===
// // //     {
// // //       id:            "minimal",
// // //       name:          "Minimal Clean",
// // //       description:   "Ultra clean whitespace. Passes all ATS scanners easily.",
// // //       tags:          ["Any Industry", "Entry Level", "Remote"],
// // //       accent:        "#059669",
// // //       headerBg:      "#059669",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "clean",
// // //     },
// // //     {
// // //       id:            "border_accent",
// // //       name:          "Border Accent",
// // //       description:   "Subtle left border accent on each section for visual hierarchy.",
// // //       tags:          ["Any Industry", "Professional", "Clean"],
// // //       accent:        "#2563eb",
// // //       headerBg:      "#f8fafc",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "clean",
// // //     },
// // //     {
// // //       id:            "minimal_luxe",
// // //       name:          "Minimal Luxe",
// // //       description:   "Premium minimal design with generous spacing and subtle accents.",
// // //       tags:          ["Executive", "Creative", "Premium"],
// // //       accent:        "#8b5cf6",
// // //       headerBg:      "#faf5ff",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "clean",
// // //     },
// // //     {
// // //       id:            "compact",
// // //       name:          "Compact",
// // //       description:   "Fits more content per page. Ideal for experienced professionals.",
// // //       tags:          ["Senior", "Management", "10+ Years"],
// // //       accent:        "#374151",
// // //       headerBg:      "#111827",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "clean",
// // //     },

// // //     // === SIDEBAR / TWO-COLUMN ===
// // //     {
// // //       id:            "sidebarlight",
// // //       name:          "Sidebar Light",
// // //       description:   "Clean light sidebar with contact info. Balanced and modern.",
// // //       tags:          ["Product", "Design", "HR"],
// // //       accent:        "#0d9488",
// // //       headerBg:      "#f0fdfa",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "sidebar",
// // //     },
// // //     {
// // //       id:            "focus_grid",
// // //       name:          "Focus Grid",
// // //       description:   "Skills-first layout with balanced two-column grid for maximum impact.",
// // //       tags:          ["Tech", "Skills", "Data"],
// // //       accent:        "#0891b2",
// // //       headerBg:      "#164e63",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "sidebar",
// // //     },

// // //     // === SPECIALTY ===
// // //     {
// // //       id:            "corporate",
// // //       name:          "Corporate",
// // //       description:   "Gradient header with professional layout for business roles.",
// // //       tags:          ["Business", "Consulting", "Banking"],
// // //       accent:        "#0369a1",
// // //       headerBg:      "#0c4a6e",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "corporate",
// // //     },
// // //     {
// // //       id:            "creative",
// // //       name:          "Creative",
// // //       description:   "Bold diagonal header with color accents for creative roles.",
// // //       tags:          ["Marketing", "Design", "Media"],
// // //       accent:        "#e11d48",
// // //       headerBg:      "#881337",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "creative",
// // //     },
// // //     {
// // //       id:            "technical",
// // //       name:          "Technical",
// // //       description:   "Code-style layout optimized for engineers and developers.",
// // //       tags:          ["Engineering", "Software", "Data Science"],
// // //       accent:        "#0891b2",
// // //       headerBg:      "#164e63",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "technical",
// // //     },
// // //     {
// // //       id:            "academic",
// // //       name:          "Academic",
// // //       description:   "Formal layout for research, academia, and PhD applications.",
// // //       tags:          ["Research", "Academia", "Science"],
// // //       accent:        "#7c3aed",
// // //       headerBg:      "#1e1b4b",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "academic",
// // //     },
// // //     {
// // //       id:            "government",
// // //       name:          "Government",
// // //       description:   "Strict formatting for federal and government job applications.",
// // //       tags:          ["Federal", "Public Sector", "Military"],
// // //       accent:        "#1e3a5f",
// // //       headerBg:      "#0f2137",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "government",
// // //     },
// // //     {
// // //       id:            "elegant",
// // //       name:          "Elegant",
// // //       description:   "Refined serif typography with a tasteful two-tone sidebar accent.",
// // //       tags:          ["Finance", "Law", "Consulting"],
// // //       accent:        "#b45309",
// // //       headerBg:      "#1c1917",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "elegant",
// // //     },
// // //     {
// // //       id:            "timeline",
// // //       name:          "Timeline",
// // //       description:   "Date-focused layout with timeline-style experience section.",
// // //       tags:          ["Executive", "Long Career", "Chronological"],
// // //       accent:        "#0f172a",
// // //       headerBg:      "#f1f5f9",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "modern",
// // //     },
// // //     {
// // //       id:            "ats_optimized",
// // //       name:          "ATS Optimized",
// // //       description:   "Clean, single-column layout specifically optimized for ATS screening systems.",
// // //       tags:          ["ATS Safe", "Universal", "Entry Level"],
// // //       accent:        "#2d3748",
// // //       headerBg:      "#1a202c",
// // //       active:        true,
// // //       showInLanding: true,
// // //       comingSoon:    false,
// // //       category:      "ats",
// // //     },
// // //   ],

// // //   // ─────────────────────────────────────────────────────────────
// // //   // PLANS — each plan is fully independent
// // //   // resumeTemplateIds → which templates this plan unlocks
// // //   // resumeTemplateCount → how many templates user can SELECT
// // //   //   (null = unlimited, 1 = pick 1, 2 = pick any 2, etc.)
// // //   // ─────────────────────────────────────────────────────────────
// // //   plans: [

// // //     // ── PLAN 1: ATS Basic ──────────────────────────────────────
// // //     {
// // //       id:           "ats_basic",
// // //       name:         "ATS Basic",
// // //       price:        "$2.99",
// // //       priceInCents: 299,
// // //       period:       "one-time",
// // //       description:  "2 ATS analyses + 1 AI-improved resume using your real data in your chosen template.",
// // //       highlight:    false,
// // //       badge:        null,
// // //       enabled:      true,
// // //       active:       true,
// // //       includes: [
// // //         "ATS_ANALYSIS",
// // //         "ATS_RESUME_IMPROVED",
// // //       ],

// // //       // Usage limits
// // //       analysisCount:    2,
// // //       resumeGenCount:   1,
// // //       coverLetterCount: 1,

// // //       // // Template access - all active templates
// // //       // resumeTemplateIds: [
// // //       //   "classic_bw", "traditional", "classic", "elevated_classic", "cleanserif",
// // //       //   "modern", "horizontal", "dual_accent", "spaced_clean",
// // //       //   "executive", "bold", "professional", "focused",
// // //       //   "minimal", "border_accent", "minimal_luxe", "compact",
// // //       //   "sidebarlight", "focus_grid",
// // //       //   "corporate", "creative", "technical", "academic", "government", "elegant", "timeline", "ats_optimized"
// // //       // ],
// // //       // Template access - all active templates
// // //       resumeTemplateIds: [
// // //         "classic_bw", "traditional", "classic", "corporate", "creative", "technical", "ats_optimized"
// // //       ],
// // //       resumeTemplateCount: 1,  // user picks 1 template per generation

// // //       features: [
// // //         { text: "2 ATS Analyses per purchase",        included: true  },
// // //         { text: "Full ATS Score (0–100)",              included: true  },
// // //         { text: "Keyword Gap Analysis",                included: true  },
// // //         { text: "Section-by-Section Feedback",         included: true  },
// // //         { text: "AI Rewrite Suggestions",              included: true  },
// // //         { text: "Downloadable Analysis Report",        included: true  },
// // //         { text: "1 AI-Improved Resume (28+ Templates)", included: true  },
// // //         { text: "Uses YOUR real resume data",          included: true  },
// // //         { text: "Missing keywords auto-injected",      included: true  },
// // //         { text: "Document Summary & Charts",           included: false },
// // //         { text: "Document Chat / Q&A",                 included: false },
// // //       ],
// // //       cta:      "Get Started",
// // //       ctaRoute: "/signup",
// // //     },

// // //     // ── PLAN 2: Document Pro ───────────────────────────────────
// // //     {
// // //       id:           "doc_pro",
// // //       name:         "Document Pro",
// // //       price:        "$2.99",
// // //       priceInCents: 299,
// // //       period:       "one-time",
// // //       description:  "AI-powered document summary with charts and interactive Q&A chat.",
// // //       highlight:    true,
// // //       badge:        "Coming Soon",
// // //       enabled:      true,
// // //       active:       false,
// // //       includes: [
// // //         "DOCUMENT_SUMMARY",
// // //         "DOCUMENT_CHAT",
// // //         "ATS_ANALYSIS",
// // //         "ATS_RESUME_SAMPLE",
// // //       ],
// // //       analysisCount:    3,
// // //       resumeGenCount:   1,

// // //       resumeTemplateIds: [
// // //         "classic_bw", "traditional", "classic", "elevated_classic", "cleanserif",
// // //         "modern", "horizontal", "dual_accent", "spaced_clean",
// // //         "executive", "bold", "professional", "focused",
// // //         "minimal", "border_accent", "minimal_luxe", "compact",
// // //         "sidebarlight", "focus_grid",
// // //         "corporate", "creative", "technical", "academic", "government", "elegant", "timeline", "ats_optimized"
// // //       ],
// // //       resumeTemplateCount: 2,  // doc_pro allows picking 2 templates

// // //       features: [
// // //         { text: "Upload Any Document (PDF, Word)",   included: true  },
// // //         { text: "AI Document Summary",               included: true  },
// // //         { text: "Key Points Extraction",             included: true  },
// // //         { text: "Visual Charts & Insights",          included: true  },
// // //         { text: "Document Chat / Q&A",               included: true  },
// // //         { text: "3 ATS Resume Analyses",             included: true  },
// // //         { text: "2 AI-Improved Resumes (28+ Templates)", included: true  },
// // //       ],
// // //       cta:      "Notify Me",
// // //       ctaRoute: "/support",
// // //     },

// // //     // ── PLAN 3: Pro Unlimited (Future) ─────────────────────────
// // //     // {
// // //     //   id:           "pro_unlimited",
// // //     //   name:         "Pro Unlimited",
// // //     //   price:        "$9.99",
// // //     //   priceInCents: 999,
// // //     //   period:       "per month",
// // //     //   description:  "Unlimited ATS analyses and resume generations.",
// // //     //   highlight:    true,
// // //     //   badge:        "Best Value",
// // //     //   enabled:      false,
// // //     //   active:       false,
// // //     //   includes: ["ATS_ANALYSIS", "ATS_RESUME_IMPROVED", "DOCUMENT_SUMMARY", "DOCUMENT_CHAT"],
// // //     //   analysisCount:    null,
// // //     //   resumeGenCount:   null,
// // //     //   resumeTemplateIds: [...allTemplateIds],
// // //     //   resumeTemplateCount: null,
// // //     //   features: [...],
// // //     //   cta: "Coming Soon",
// // //     //   ctaRoute: "/support",
// // //     // },
// // //   ],

// // //   // ─────────────────────────────────────────────────────────────
// // //   // SERVICES
// // //   // ─────────────────────────────────────────────────────────────
// // //   services: [
// // //     {
// // //       id:          "ats_analysis",
// // //       serviceCode: "ATS_ANALYSIS",
// // //       planId:      "ats_basic",
// // //       isFree:      false,
// // //       icon:        "🎯",
// // //       title:       "ATS Resume Analysis",
// // //       description: "Detailed ATS score, keyword gap analysis, section feedback and AI rewrite suggestions.",
// // //       badge:       null,
// // //       active:      true,
// // //       enabled:     true,
// // //       comingSoon:  false,
// // //       highlights:  ["ATS Score 0–100", "Keyword Gap Analysis", "AI Feedback"],
// // //       route:       null,
// // //     },
// // //     {
// // //       id:          "ats_resume_sample",
// // //       serviceCode: "ATS_RESUME_SAMPLE",
// // //       planId:      "ats_basic",
// // //       isFree:      true,
// // //       icon:        "✨",
// // //       title:       "Sample ATS Resume",
// // //       description: "Generate a fully ATS-optimized sample resume in your chosen template.",
// // //       badge:       "FREE",
// // //       badgeColor:  "#3B6D11",
// // //       badgeBg:     "#EAF3DE",
// // //       active:      true,
// // //       enabled:     true,
// // //       comingSoon:  false,
// // //       highlights:  ["28+ Templates", "AI-Powered", "PDF + Word + HTML"],
// // //       route:       "/generate-resume",
// // //     },
// // //     {
// // //       id:          "document_summary",
// // //       serviceCode: "DOCUMENT_SUMMARY",
// // //       planId:      "doc_pro",
// // //       isFree:      false,
// // //       icon:        "📊",
// // //       title:       "Document Summary",
// // //       description: "Upload any document and get an AI summary with visual charts and key insights.",
// // //       badge:       null,
// // //       active:      false,
// // //       enabled:     true,
// // //       comingSoon:  true,
// // //       highlights:  ["AI Summary", "Visual Charts", "Key Points"],
// // //       route:       "/document-summary",
// // //     },
// // //     {
// // //       id:          "document_chat",
// // //       serviceCode: "DOCUMENT_CHAT",
// // //       planId:      "doc_pro",
// // //       isFree:      false,
// // //       icon:        "💬",
// // //       title:       "Document Chat",
// // //       description: "Ask questions and have a conversation with any document using AI.",
// // //       badge:       null,
// // //       active:      false,
// // //       enabled:     true,
// // //       comingSoon:  true,
// // //       highlights:  ["Ask Questions", "AI Answers", "Any Document"],
// // //       route:       "/document-chat",
// // //     },
// // //   ],

// // //   // ─────────────────────────────────────────────────────────────
// // //   // STEPS, STATS, FAQ
// // //   // ─────────────────────────────────────────────────────────────
// // //   steps: [
// // //     { num: "1", icon: "🎯", label: "Select Plan",              desc: "Choose the plan you need."            },
// // //     { num: "2", icon: "💳", label: "Pay",                      desc: "One-time payment, no subscriptions.", priceRef: true },
// // //     { num: "3", icon: "📄", label: "Upload Resume / Document", desc: "Word, PDF, or paste text."            },
// // //     { num: "4", icon: "📋", label: "Paste Job Description",    desc: "Copy from any job board."             },
// // //     { num: "5", icon: "🚀", label: "Get Your Results",         desc: "Download, chat, or analyze."          },
// // //   ],

// // //   stats: [
// // //     { value: "90%+",  label: "ATS Compatibility Rate"  },
// // //     { value: "$2.99", label: "Starting Price"           },
// // //     { value: "60s",   label: "Average Analysis Time"    },
// // //     { value: "28+",   label: "Professional Templates"   },
// // //   ],

// // //   faq: [
// // //     {
// // //       q: "What is an ATS score?",
// // //       a: "An ATS (Applicant Tracking System) score measures how well your resume matches a job description. Most companies use ATS software to filter resumes before a human sees them. A higher score means more chances of getting noticed.",
// // //     },
// // //     {
// // //       q: "What does ATS Basic include?",
// // //       a: "ATS Basic ($2.99) includes a full ATS resume analysis with scoring, keyword gap analysis, section feedback, AI rewrite suggestions, a downloadable report, and one free AI-improved resume generator with access to all 28+ professional templates.",
// // //     },
// // //     {
// // //       q: "How many resume templates are available?",
// // //       a: "ATS Basic includes access to all 28+ resume templates across multiple categories: Classic, Modern, Executive, Clean, Sidebar, Specialty, and ATS-optimized. You select one template per generation. Each paid analysis unlocks one free resume generation.",
// // //     },
// // //     {
// // //       q: "What templates are available?",
// // //       a: "We offer a wide range of templates including: Classic ATS, Modern Pro, Executive, Minimal Clean, Corporate, Creative, Technical, Elegant, Bold, Sidebar Light, Academic, Professional, Compact, Clean Serif, Government, Traditional, Classic B&W, plus new designs like Horizontal Header, Border Accent, Timeline, Dual Accent, Minimal Luxe, Focus Grid, Elevated Classic, Spaced Clean, Focused, and ATS Optimized.",
// // //     },
// // //     {
// // //       q: "What does Document Pro include?",
// // //       a: "Document Pro includes AI-powered document summarization with visual charts, key points extraction, and an interactive Q&A chat. Coming soon!",
// // //     },
// // //     {
// // //       q: "Are the plans cumulative?",
// // //       a: "No — each plan is independent. You pay for what you need.",
// // //     },
// // //     {
// // //       q: "Is there a subscription?",
// // //       a: "No subscriptions. Each plan is a one-time payment, only when you need it.",
// // //     },
// // //     {
// // //       q: "What file formats are supported?",
// // //       a: "Resume analysis: Word (.docx) or paste plain text. Reports download in PDF, Word, or HTML.",
// // //     },
// // //     {
// // //       q: "Is my data secure?",
// // //       a: "Yes. Your data is stored securely and never shared with third parties. Payments are processed by Stripe with bank-level encryption.",
// // //     },
// // //   ],
// // // };

// // // export default servicesConfig;

// // // src/utils/servicesConfig.js
// // //
// // // ═══════════════════════════════════════════════════════════════
// // // HOW TO CONFIGURE
// // // ═══════════════════════════════════════════════════════════════
// // //
// // // ADD A NEW PLAN:
// // //   1. Add to plans[] with unique id, price, includes[]
// // //   2. Add price to backend/server.js PLAN_PRICES
// // //   3. Set enabled/active: true when ready
// // //
// // // ADD A NEW SERVICE:
// // //   1. Add to services[] with unique serviceCode
// // //   2. Add serviceCode to relevant plan includes[]
// // //
// // // ADD A NEW RESUME TEMPLATE:
// // //   1. Add to resumeTemplates[] with unique id
// // //   2. Add id to relevant plan resumeTemplateIds[]
// // //   3. Add rendering in ResumeGeneratorPage.jsx
// // //   4. Add styling in generateResumeDoc.js
// // //
// // // CONTROL TEMPLATE ACCESS PER PLAN:
// // //   Set resumeTemplateCount — how many templates user can choose from
// // //   Set resumeTemplateIds   — which specific templates are available
// // //
// // // ═══════════════════════════════════════════════════════════════

// // const servicesConfig = {

// //   // ─────────────────────────────────────────────────────────────
// //   // APP BRANDING — change here, updates everywhere automatically
// //   // ─────────────────────────────────────────────────────────────
// //   app: {
// //     name:        "ResumeScoreAI",
// //     tagline:     "Beat the ATS. Get the interview.",        // ← hero headline suffix
// //     taglinePre:  "Beat the ATS.",                           // ← line 1 of split tagline
// //     taglinePost: "Get the interview.",                      // ← line 2 of split tagline
// //     description: "AI-powered ATS resume analysis and generation — beat the ATS, get the interview.",
// //     shortDesc:   "Beat the ATS. Get the interview.",        // ← used in meta, footer
// //     ctaHero:     "Analyze My Resume",                       // ← primary CTA button text
// //     ctaNav:      "Get Started Free",                        // ← nav CTA for logged-out
// //     ctaNavUser:  "New Analysis",                            // ← nav CTA for logged-in
// //     supportHours:"48 hours",                                // ← support response time
// //     domain:      "smartaicareer.com",
// //     email:       "support@smartaicareer.com",
// //     twitter:     "",
// //     linkedin:    "",
// //   },

// //   // ─────────────────────────────────────────────────────────────
// //   // RESUME TEMPLATES
// //   // Single source of truth for all available templates.
// //   // Access per plan is controlled via plan.resumeTemplateIds[]
// //   // ─────────────────────────────────────────────────────────────
// //   // ─────────────────────────────────────────────────────────────
// //   // RESUME TEMPLATES
// //   //
// //   // Each template has these control flags:
// //   //   active:     true  → built, tested, available for use
// //   //               false → disabled globally (not shown anywhere)
// //   //   showInLanding: true  → shown in landing page carousel
// //   //   comingSoon: true  → show greyed-out with "Coming Soon" badge
// //   //
// //   // Plan access is controlled via plans[].resumeTemplateIds[]
// //   // To add a new template:
// //   //   1. Add entry here with active: false, comingSoon: true
// //   //   2. Build the renderer in TemplateMini.jsx, ResumePreview, generateResumeDoc.js
// //   //   3. Set active: true when ready
// //   //   4. Add id to relevant plan's resumeTemplateIds[]
// //   // ─────────────────────────────────────────────────────────────
// //   resumeTemplates: [
// //     {
// //       id:            "classic",
// //       name:          "Classic ATS",
// //       description:   "Clean single-column layout. Best for traditional industries.",
// //       tags:          ["Finance", "Law", "Healthcare"],
// //       accent:        "#2563eb",
// //       headerBg:      "#1e293b",
// //       active:        true,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "modern",
// //       name:          "Modern Pro",
// //       description:   "Bold sidebar with skill bars. Great for tech roles.",
// //       tags:          ["Tech", "Engineering", "Design"],
// //       accent:        "#7c3aed",
// //       headerBg:      "#7c3aed",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "executive",
// //       name:          "Executive",
// //       description:   "Dark full-width header for senior-level positions.",
// //       tags:          ["Management", "C-Suite", "Director"],
// //       accent:        "#334155",
// //       headerBg:      "#0f172a",
// //       active:        true,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "minimal",
// //       name:          "Minimal Clean",
// //       description:   "Ultra clean whitespace. Passes all ATS scanners easily.",
// //       tags:          ["Any Industry", "Entry Level", "Remote"],
// //       accent:        "#059669",
// //       headerBg:      "#059669",
// //       active:        true,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "corporate",
// //       name:          "Corporate",
// //       description:   "Gradient header with professional layout for business roles.",
// //       tags:          ["Business", "Consulting", "Banking"],
// //       accent:        "#0369a1",
// //       headerBg:      "#0c4a6e",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "creative",
// //       name:          "Creative",
// //       description:   "Bold diagonal header with color accents for creative roles.",
// //       tags:          ["Marketing", "Design", "Media"],
// //       accent:        "#e11d48",
// //       headerBg:      "#881337",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "technical",
// //       name:          "Technical",
// //       description:   "Code-style layout optimized for engineers and developers.",
// //       tags:          ["Engineering", "Software", "Data Science"],
// //       accent:        "#0891b2",
// //       headerBg:      "#164e63",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "elegant",
// //       name:          "Elegant",
// //       description:   "Refined serif typography with a tasteful two-tone sidebar accent.",
// //       tags:          ["Finance", "Law", "Consulting"],
// //       accent:        "#b45309",
// //       headerBg:      "#1c1917",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "bold",
// //       name:          "Bold Impact",
// //       description:   "Large name, strong section dividers. Stands out in any stack.",
// //       tags:          ["Sales", "Marketing", "Operations"],
// //       accent:        "#1d4ed8",
// //       headerBg:      "#1e3a8a",
// //       active:        true,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "sidebarlight",
// //       name:          "Sidebar Light",
// //       description:   "Clean light sidebar with contact info. Balanced and modern.",
// //       tags:          ["Product", "Design", "HR"],
// //       accent:        "#0d9488",
// //       headerBg:      "#f0fdfa",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "academic",
// //       name:          "Academic",
// //       description:   "Formal layout for research, academia, and PhD applications.",
// //       tags:          ["Research", "Academia", "Science"],
// //       accent:        "#7c3aed",
// //       headerBg:      "#1e1b4b",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "professional",
// //       name:          "Professional",
// //       description:   "Traditional two-column header, clean lines. Universal ATS compatibility.",
// //       tags:          ["Finance", "Banking", "Insurance"],
// //       accent:        "#1e3a5f",
// //       headerBg:      "#1e3a5f",
// //       active:        true,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "compact",
// //       name:          "Compact",
// //       description:   "Fits more content per page. Ideal for experienced professionals.",
// //       tags:          ["Senior", "Management", "10+ Years"],
// //       accent:        "#374151",
// //       headerBg:      "#111827",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "cleanserif",
// //       name:          "Clean Serif",
// //       description:   "Warm serif fonts with generous spacing. Great for non-tech industries.",
// //       tags:          ["Healthcare", "Education", "Nonprofit"],
// //       accent:        "#7f1d1d",
// //       headerBg:      "#450a0a",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     {
// //       id:            "government",
// //       name:          "Government",
// //       description:   "Strict formatting for federal and government job applications.",
// //       tags:          ["Federal", "Public Sector", "Military"],
// //       accent:        "#1e3a5f",
// //       headerBg:      "#0f2137",
// //       active:        false,
// //       showInLanding: true,
// //       comingSoon:    false,
// //     },
// //     // ── Future templates — set active:false until renderer is built ──
// //     // {
// //     //   id:            "infographic",
// //     //   name:          "Infographic",
// //     //   description:   "Visual icons and charts for data-heavy profiles.",
// //     //   tags:          ["Data", "Analytics", "Research"],
// //     //   accent:        "#f59e0b",
// //     //   headerBg:      "#92400e",
// //     //   active:        false,
// //     //   showInLanding: false,
// //     //   comingSoon:    true,
// //     // },
// //   ],

// //   // ─────────────────────────────────────────────────────────────
// //   // PLANS — each plan is fully independent
// //   // resumeTemplateIds  → which templates this plan unlocks
// //   // resumeTemplateCount → how many templates user can SELECT
// //   //   (null = unlimited, 1 = pick 1, 2 = pick any 2, etc.)
// //   // ─────────────────────────────────────────────────────────────
// //   plans: [

// //     // ── PLAN 1: ATS Basic ──────────────────────────────────────
// //     {
// //       id:           "ats_basic",
// //       name:         "ATS Basic",
// //       price:        "$4.99",
// //       priceInCents: 499,
// //       period:       "one-time",
// //       description:  "2 ATS analyses + 1 AI-improved resume using your real data in your chosen template.",
// //       highlight:    false,
// //       badge:        null,
// //       enabled:      true,
// //       active:       true,
// //       includes: [
// //         "ATS_ANALYSIS",
// //         "ATS_RESUME_IMPROVED", // renamed from SAMPLE — now uses real resume data
// //       ],

// //       // ── Usage limits (configurable here) ──
// //       analysisCount:    3,  // how many ATS analyses allowed per purchase
// //       resumeGenCount:   1,  // how many resume generations allowed per purchase
// //       coverLetterCount: 1,  // how many cover letters allowed per purchase

// //       // ── Template access ──
// //       // List ONLY the template ids this plan allows.
// //       // Users see exactly these templates during resume generation.
// //       // To add/remove: edit the array below and redeploy frontend only.
// //       // Upgrade plans can have more templates (e.g. doc_pro gets all 7).
// //       // Only templates with full download support (PDF/Word/HTML all match preview exactly)
// //       resumeTemplateIds:   ["classic", "executive", "bold", "minimal", "professional"],
// //       resumeTemplateCount: 1,  // user picks 1 template per generation

// //       features: [
// //         { text: "2 ATS Analyses per purchase",        included: true  },
// //         { text: "Full ATS Score (0–100)",              included: true  },
// //         { text: "Keyword Gap Analysis",                included: true  },
// //         { text: "Section-by-Section Feedback",         included: true  },
// //         { text: "AI Rewrite Suggestions",              included: true  },
// //         { text: "Downloadable Analysis Report",        included: true  },
// //         { text: "1 AI-Improved Resume (Multiple Templates)",  included: true  },
// //         { text: "Uses YOUR real resume data",          included: true  },
// //         { text: "Missing keywords auto-injected",      included: true  },
// //         { text: "Document Summary & Charts",           included: false },
// //         { text: "Document Chat / Q&A",                 included: false },
// //       ],
// //       cta:      "Get Started",
// //       ctaRoute: "/signup",
// //     },

// //     // ── PLAN 2: Document Pro ───────────────────────────────────
// //     {
// //       id:           "doc_pro",
// //       name:         "Document Pro",
// //       price:        "$2.99",
// //       priceInCents: 299,
// //       period:       "one-time",
// //       description:  "AI-powered document summary with charts and interactive Q&A chat.",
// //       highlight:    true,
// //       badge:        "Coming Soon",
// //       enabled:      true,
// //       active:       false,
// //       includes: [
// //         "DOCUMENT_SUMMARY",
// //         "DOCUMENT_CHAT",
// //         "ATS_ANALYSIS",
// //         "ATS_RESUME_SAMPLE",
// //       ],
// //       // ── Usage limits ──
// //       analysisCount:    3,  // doc_pro gets more analyses
// //       resumeGenCount:   1,

// //       // ── Template access ──
// //       // ── Template access — doc_pro gets ALL templates as upgrade incentive ──
// //       resumeTemplateIds: [
// //         "classic", "executive", "bold", "minimal", "professional"
// //       ],
// //       resumeTemplateCount: 1,
// //       features: [
// //         { text: "Upload Any Document (PDF, Word)",        included: true  },
// //         { text: "AI Document Summary",                    included: true  },
// //         { text: "Key Points Extraction",                  included: true  },
// //         { text: "Visual Charts & Insights",               included: true  },
// //         { text: "Document Chat / Q&A",                    included: true  },
// //         { text: "3 ATS Resume Analyses",                  included: true  },
// //         { text: "1 AI-Improved Resume (5 Templates)",     included: true  },
// //         { text: "Cover Letter Generator",                 included: true  },
// //       ],
// //       cta:      "Notify Me",
// //       ctaRoute: "/support",
// //     },
// //   ],

// //   // ─────────────────────────────────────────────────────────────
// //   // SERVICES
// //   // ─────────────────────────────────────────────────────────────
// //   services: [
// //     {
// //       id:          "ats_analysis",
// //       serviceCode: "ATS_ANALYSIS",
// //       planId:      "ats_basic",
// //       isFree:      false,
// //       icon:        "🎯",
// //       title:       "ATS Resume Analysis",
// //       description: "Detailed ATS score, keyword gap analysis, section feedback and AI rewrite suggestions.",
// //       badge:       null,
// //       active:      true,
// //       enabled:     true,
// //       comingSoon:  false,
// //       highlights:  ["ATS Score 0–100", "Keyword Gap Analysis", "AI Feedback"],
// //       route:       null,
// //     },
// //     {
// //       id:          "ats_resume_improved",
// //       serviceCode: "ATS_RESUME_IMPROVED",
// //       planId:      "ats_basic",
// //       isFree:      true,
// //       icon:        "✨",
// //       title:       "AI-Improved Resume",
// //       description: "Generate an ATS-optimized resume using your real data in your chosen template.",
// //       badge:       "FREE",
// //       badgeColor:  "#3B6D11",
// //       badgeBg:     "#EAF3DE",
// //       active:      true,
// //       enabled:     true,
// //       comingSoon:  false,
// //       highlights:  ["5 Pro Templates", "AI-Powered", "PDF + Word + HTML"],
// //       route:       "/generate-resume",
// //     },
// //     {
// //       id:          "cover_letter",
// //       serviceCode: "COVER_LETTER",
// //       planId:      "ats_basic",
// //       isFree:      true,
// //       icon:        "📝",
// //       title:       "Cover Letter Generator",
// //       description: "AI-generated cover letter tailored to the job description.",
// //       badge:       "FREE",
// //       badgeColor:  "#3B6D11",
// //       badgeBg:     "#EAF3DE",
// //       active:      true,
// //       enabled:     true,
// //       comingSoon:  false,
// //       highlights:  ["AI-Powered", "Job Tailored", "PDF + Word + TXT"],
// //       route:       "/cover-letter",
// //     },
// //     {
// //       id:          "document_summary",
// //       serviceCode: "DOCUMENT_SUMMARY",
// //       planId:      "doc_pro",
// //       isFree:      false,
// //       icon:        "📊",
// //       title:       "Document Summary",
// //       description: "Upload any document and get an AI summary with visual charts and key insights.",
// //       badge:       null,
// //       active:      false,
// //       enabled:     true,
// //       comingSoon:  true,
// //       highlights:  ["AI Summary", "Visual Charts", "Key Points"],
// //       route:       "/document-summary",
// //     },
// //     {
// //       id:          "document_chat",
// //       serviceCode: "DOCUMENT_CHAT",
// //       planId:      "doc_pro",
// //       isFree:      false,
// //       icon:        "💬",
// //       title:       "Document Chat",
// //       description: "Ask questions and have a conversation with any document using AI.",
// //       badge:       null,
// //       active:      false,
// //       enabled:     true,
// //       comingSoon:  true,
// //       highlights:  ["Ask Questions", "AI Answers", "Any Document"],
// //       route:       "/document-chat",
// //     },
// //   ],

// //   // ─────────────────────────────────────────────────────────────
// //   // HOW IT WORKS STEPS
// //   // ─────────────────────────────────────────────────────────────
// //   steps: [
// //     { num: "1", icon: "🎯", label: "Select Plan",              desc: "Choose the plan you need."            },
// //     { num: "2", icon: "💳", label: "Pay",                      desc: "One-time payment, no subscriptions.", priceRef: true },
// //     { num: "3", icon: "📄", label: "Upload Resume / Document", desc: "Word, PDF, or paste text."            },
// //     { num: "4", icon: "📋", label: "Paste Job Description",    desc: "Copy from any job board."             },
// //     { num: "5", icon: "🚀", label: "Get Your Results",         desc: "Download, chat, or analyze."          },
// //   ],

// //   // ─────────────────────────────────────────────────────────────
// //   // STATS
// //   // ─────────────────────────────────────────────────────────────
// //   stats: [
// //     { value: "90%+",  label: "ATS Compatibility Rate"  },
// //     { value: "$1.99", label: "Starting Price"           },
// //     { value: "60s",   label: "Average Analysis Time"    },
// //     { value: "5",     label: "Professional Templates"   },
// //   ],

// //   // ─────────────────────────────────────────────────────────────
// //   // FAQ
// //   // ─────────────────────────────────────────────────────────────
// //   faq: [
// //     {
// //       q: "What is an ATS score?",
// //       a: "An ATS (Applicant Tracking System) score measures how well your resume matches a job description. Most companies use ATS software to filter resumes before a human sees them. A higher score means more chances of getting noticed.",
// //     },
// //     {
// //       q: "What does ATS Basic include?",
// //       a: "ATS Basic ($1.99) includes 2 ATS resume analyses with scoring, keyword gap analysis, section feedback, AI rewrite suggestions, and one free AI-improved resume generator with access to 5 professional templates. Also includes 1 cover letter generation.",
// //     },
// //     {
// //       q: "What resume templates are available?",
// //       a: "ATS Basic includes 5 fully supported templates: Classic ATS, Executive, Bold Impact, Minimal Clean, and Professional. All templates produce identical output across PDF, Word, and HTML downloads.",
// //     },
// //     {
// //       q: "Will the downloaded resume match what I see on screen?",
// //       a: "Yes — PDF, Word, and HTML downloads all use the same HTML generator as the screen preview, so what you see is exactly what you get.",
// //     },
// //     {
// //       q: "Is there a subscription?",
// //       a: "No subscriptions. Each plan is a one-time payment, only when you need it.",
// //     },
// //     {
// //       q: "What file formats are supported for upload?",
// //       a: "Resume analysis: Word (.docx) or paste plain text. Downloaded resumes are available in PDF, Word (.doc), or HTML.",
// //     },
// //     {
// //       q: "Are the plans cumulative?",
// //       a: "No — each plan is independent. You pay for what you need.",
// //     },
// //     {
// //       q: "Is my data secure?",
// //       a: "Yes. Your data is stored securely and never shared with third parties. Payments are processed by Stripe with bank-level encryption.",
// //     },
// //     {
// //       q: "What does Document Pro include?",
// //       a: "Document Pro includes AI-powered document summarization with visual charts, key points extraction, and an interactive Q&A chat. Coming soon!",
// //     },
// //   ],
// // };

// // export default servicesConfig;

// //new code in the evening
// const servicesConfig = {

//   // ─────────────────────────────────────────────────────────────
//   // APP BRANDING — change here, updates everywhere automatically
//   // ─────────────────────────────────────────────────────────────
//   app: {
//     name:        "ResumeScoreAI",
//     tagline:     "Beat the ATS. Get the interview.",        // ← hero headline suffix
//     taglinePre:  "Beat the ATS.",                           // ← line 1 of split tagline
//     taglinePost: "Get the interview.",                      // ← line 2 of split tagline
//     description: "AI-powered ATS resume analysis and generation — beat the ATS, get the interview.",
//     shortDesc:   "Beat the ATS. Get the interview.",        // ← used in meta, footer
//     ctaHero:     "Analyze My Resume",                       // ← primary CTA button text
//     ctaNav:      "Get Started Free",                        // ← nav CTA for logged-out
//     ctaNavUser:  "New Analysis",                            // ← nav CTA for logged-in
//     supportHours:"48 hours",                                // ← support response time
//     domain:      "smartaicareer.com",
//     email:       "support@smartaicareer.com",
//     twitter:     "",
//     linkedin:    "",
//   },

//   // ─────────────────────────────────────────────────────────────
//   // RESUME TEMPLATES
//   // Single source of truth for all available templates.
//   // Access per plan is controlled via plan.resumeTemplateIds[]
//   // ─────────────────────────────────────────────────────────────
//   // ─────────────────────────────────────────────────────────────
//   // RESUME TEMPLATES
//   //
//   // Each template has these control flags:
//   //   active:     true  → built, tested, available for use
//   //               false → disabled globally (not shown anywhere)
//   //   showInLanding: true  → shown in landing page carousel
//   //   comingSoon: true  → show greyed-out with "Coming Soon" badge
//   //
//   // Plan access is controlled via plans[].resumeTemplateIds[]
//   // To add a new template:
//   //   1. Add entry here with active: false, comingSoon: true
//   //   2. Build the renderer in TemplateMini.jsx, ResumePreview, generateResumeDoc.js
//   //   3. Set active: true when ready
//   //   4. Add id to relevant plan's resumeTemplateIds[]
//   // ─────────────────────────────────────────────────────────────
//   resumeTemplates: [
//     {
//       id:            "classic",
//       name:          "Classic ATS",
//       description:   "Clean single-column layout. Best for traditional industries.",
//       tags:          ["Finance", "Law", "Healthcare"],
//       accent:        "#2563eb",
//       headerBg:      "#1e293b",
//       active:        true,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "modern",
//       name:          "Modern Pro",
//       description:   "Bold sidebar with skill bars. Great for tech roles.",
//       tags:          ["Tech", "Engineering", "Design"],
//       accent:        "#7c3aed",
//       headerBg:      "#7c3aed",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "executive",
//       name:          "Executive",
//       description:   "Dark full-width header for senior-level positions.",
//       tags:          ["Management", "C-Suite", "Director"],
//       accent:        "#334155",
//       headerBg:      "#0f172a",
//       active:        true,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "minimal",
//       name:          "Minimal Clean",
//       description:   "Ultra clean whitespace. Passes all ATS scanners easily.",
//       tags:          ["Any Industry", "Entry Level", "Remote"],
//       accent:        "#059669",
//       headerBg:      "#059669",
//       active:        true,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "corporate",
//       name:          "Corporate",
//       description:   "Gradient header with professional layout for business roles.",
//       tags:          ["Business", "Consulting", "Banking"],
//       accent:        "#0369a1",
//       headerBg:      "#0c4a6e",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "creative",
//       name:          "Creative",
//       description:   "Bold diagonal header with color accents for creative roles.",
//       tags:          ["Marketing", "Design", "Media"],
//       accent:        "#e11d48",
//       headerBg:      "#881337",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "technical",
//       name:          "Technical",
//       description:   "Code-style layout optimized for engineers and developers.",
//       tags:          ["Engineering", "Software", "Data Science"],
//       accent:        "#0891b2",
//       headerBg:      "#164e63",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "elegant",
//       name:          "Elegant",
//       description:   "Refined serif typography with a tasteful two-tone sidebar accent.",
//       tags:          ["Finance", "Law", "Consulting"],
//       accent:        "#b45309",
//       headerBg:      "#1c1917",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "bold",
//       name:          "Bold Impact",
//       description:   "Large name, strong section dividers. Stands out in any stack.",
//       tags:          ["Sales", "Marketing", "Operations"],
//       accent:        "#1d4ed8",
//       headerBg:      "#1e3a8a",
//       active:        true,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "sidebarlight",
//       name:          "Sidebar Light",
//       description:   "Clean light sidebar with contact info. Balanced and modern.",
//       tags:          ["Product", "Design", "HR"],
//       accent:        "#0d9488",
//       headerBg:      "#f0fdfa",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "academic",
//       name:          "Academic",
//       description:   "Formal layout for research, academia, and PhD applications.",
//       tags:          ["Research", "Academia", "Science"],
//       accent:        "#7c3aed",
//       headerBg:      "#1e1b4b",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "professional",
//       name:          "Professional",
//       description:   "Traditional two-column header, clean lines. Universal ATS compatibility.",
//       tags:          ["Finance", "Banking", "Insurance"],
//       accent:        "#1e3a5f",
//       headerBg:      "#1e3a5f",
//       active:        true,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "compact",
//       name:          "Compact",
//       description:   "Fits more content per page. Ideal for experienced professionals.",
//       tags:          ["Senior", "Management", "10+ Years"],
//       accent:        "#374151",
//       headerBg:      "#111827",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "cleanserif",
//       name:          "Clean Serif",
//       description:   "Warm serif fonts with generous spacing. Great for non-tech industries.",
//       tags:          ["Healthcare", "Education", "Nonprofit"],
//       accent:        "#7f1d1d",
//       headerBg:      "#450a0a",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     {
//       id:            "government",
//       name:          "Government",
//       description:   "Strict formatting for federal and government job applications.",
//       tags:          ["Federal", "Public Sector", "Military"],
//       accent:        "#1e3a5f",
//       headerBg:      "#0f2137",
//       active:        false,
//       showInLanding: true,
//       comingSoon:    false,
//     },
//     // ── Future templates — set active:false until renderer is built ──
//     // {
//     //   id:            "infographic",
//     //   name:          "Infographic",
//     //   description:   "Visual icons and charts for data-heavy profiles.",
//     //   tags:          ["Data", "Analytics", "Research"],
//     //   accent:        "#f59e0b",
//     //   headerBg:      "#92400e",
//     //   active:        false,
//     //   showInLanding: false,
//     //   comingSoon:    true,
//     // },
//   ],

//   // ─────────────────────────────────────────────────────────────
//   // PLANS — each plan is fully independent
//   // resumeTemplateIds  → which templates this plan unlocks
//   // resumeTemplateCount → how many templates user can SELECT
//   //   (null = unlimited, 1 = pick 1, 2 = pick any 2, etc.)
//   // ─────────────────────────────────────────────────────────────
//   plans: [

//     // ── PLAN 1: ATS Basic ──────────────────────────────────────
//     {
//       id:           "ats_basic",
//       name:         "ATS Basic",
//       price:        "$4.99",
//       priceInCents: 499,
//       period:       "one-time",
//       description:  "2 ATS analyses + 1 AI-improved resume using your real data in your chosen template.",
//       highlight:    false,
//       badge:        null,
//       enabled:      true,
//       active:       true,
//       includes: [
//         "ATS_ANALYSIS",
//         "ATS_RESUME_IMPROVED", // renamed from SAMPLE — now uses real resume data
//       ],

//       // ── Usage limits (configurable here) ──
//       analysisCount:    3,  // how many ATS analyses allowed per purchase
//       resumeGenCount:   1,  // how many resume generations allowed per purchase
//       coverLetterCount: 1,  // how many cover letters allowed per purchase
//       scratchResumeCount: 1,  // how many "build from scratch" resumes allowed per purchase


//       // ── Template access ──
//       // List ONLY the template ids this plan allows.
//       // Users see exactly these templates during resume generation.
//       // To add/remove: edit the array below and redeploy frontend only.
//       // Upgrade plans can have more templates (e.g. doc_pro gets all 7).
//       // Only templates with full download support (PDF/Word/HTML all match preview exactly)
//       resumeTemplateIds:   ["classic", "executive", "bold", "minimal", "professional"],
//       resumeTemplateCount: 1,  // user picks 1 template per generation

//       features: [
//         { text: "2 ATS Analyses per purchase",        included: true  },
//         { text: "Full ATS Score (0–100)",              included: true  },
//         { text: "Keyword Gap Analysis",                included: true  },
//         { text: "Section-by-Section Feedback",         included: true  },
//         { text: "AI Rewrite Suggestions",              included: true  },
//         { text: "Downloadable Analysis Report",        included: true  },
//         { text: "1 AI-Improved Resume (Multiple Templates)",  included: true  },
//         { text: "1 AI-Powered Resume (Multiple Templates) from scratch",  included: true  },
//         { text: "Uses YOUR real resume data",          included: true  },
//         { text: "Missing keywords auto-injected",      included: true  },
//         { text: "Document Summary & Charts",           included: false },
//         { text: "Document Chat / Q&A",                 included: false },
//       ],
//       cta:      "Get Started",
//       ctaRoute: "/signup",
//     },

//     // ── PLAN 2: Document Pro ───────────────────────────────────
//     {
//       id:           "doc_pro",
//       name:         "Document Pro",
//       price:        "$6.99",
//       priceInCents: 699,
//       period:       "one-time",
//       description:  "AI-powered document summary with charts and interactive Q&A chat.",
//       highlight:    true,
//       badge:        "Coming Soon",
//       enabled:      true,
//       active:       false,
//       includes: [
//         "DOCUMENT_SUMMARY",
//         "DOCUMENT_CHAT",
//         "ATS_ANALYSIS",
//         "ATS_RESUME_SAMPLE",
//       ],
//       // ── Usage limits ──
//       analysisCount:    3,  // doc_pro gets more analyses
//       resumeGenCount:   1,

//       // ── Template access ──
//       // ── Template access — doc_pro gets ALL templates as upgrade incentive ──
//       resumeTemplateIds: [
//         "classic", "executive", "bold", "minimal", "professional"
//       ],
//       resumeTemplateCount: 1,
//       features: [
//         { text: "Upload Any Document (PDF, Word)",        included: true  },
//         { text: "AI Document Summary",                    included: true  },
//         { text: "Key Points Extraction",                  included: true  },
//         { text: "Visual Charts & Insights",               included: true  },
//         { text: "Document Chat / Q&A",                    included: true  },
//         { text: "3 ATS Resume Analyses",                  included: true  },
//         { text: "1 AI-Improved Resume (5 Templates)",     included: true  },
//         { text: "Cover Letter Generator",                 included: true  },
//       ],
//       cta:      "Notify Me",
//       ctaRoute: "/support",
//     },
//   ],

//   // ─────────────────────────────────────────────────────────────
//   // SERVICES
//   // ─────────────────────────────────────────────────────────────
//   services: [
//     {
//       id:          "ats_analysis",
//       serviceCode: "ATS_ANALYSIS",
//       planId:      "ats_basic",
//       isFree:      false,
//       icon:        "🎯",
//       title:       "ATS Resume Analysis",
//       description: "Detailed ATS score, keyword gap analysis, section feedback and AI rewrite suggestions.",
//       badge:       null,
//       active:      true,
//       enabled:     true,
//       comingSoon:  false,
//       highlights:  ["ATS Score 0–100", "Keyword Gap Analysis", "AI Feedback"],
//       route:       null,
//     },
//     {
//       id:          "ats_resume_improved",
//       serviceCode: "ATS_RESUME_IMPROVED",
//       planId:      "ats_basic",
//       isFree:      true,
//       icon:        "✨",
//       title:       "AI-Improved Resume",
//       description: "Generate an ATS-optimized resume using your real data in your chosen template.",
//       badge:       "FREE",
//       badgeColor:  "#3B6D11",
//       badgeBg:     "#EAF3DE",
//       active:      true,
//       enabled:     true,
//       comingSoon:  false,
//       highlights:  ["5 Pro Templates", "AI-Powered", "PDF + Word + HTML"],
//       route:       "/generate-resume",
//     },
//     {
//       id:          "cover_letter",
//       serviceCode: "COVER_LETTER",
//       planId:      "ats_basic",
//       isFree:      true,
//       icon:        "📝",
//       title:       "Cover Letter Generator",
//       description: "AI-generated cover letter tailored to the job description.",
//       badge:       "FREE",
//       badgeColor:  "#3B6D11",
//       badgeBg:     "#EAF3DE",
//       active:      true,
//       enabled:     true,
//       comingSoon:  false,
//       highlights:  ["AI-Powered", "Job Tailored", "PDF + Word + TXT"],
//       route:       "/cover-letter",
//     },
//     {
//       id:          "document_summary",
//       serviceCode: "DOCUMENT_SUMMARY",
//       planId:      "doc_pro",
//       isFree:      false,
//       icon:        "📊",
//       title:       "Document Summary",
//       description: "Upload any document and get an AI summary with visual charts and key insights.",
//       badge:       null,
//       active:      false,
//       enabled:     true,
//       comingSoon:  true,
//       highlights:  ["AI Summary", "Visual Charts", "Key Points"],
//       route:       "/document-summary",
//     },
//     {
//       id:          "document_chat",
//       serviceCode: "DOCUMENT_CHAT",
//       planId:      "doc_pro",
//       isFree:      false,
//       icon:        "💬",
//       title:       "Document Chat",
//       description: "Ask questions and have a conversation with any document using AI.",
//       badge:       null,
//       active:      false,
//       enabled:     true,
//       comingSoon:  true,
//       highlights:  ["Ask Questions", "AI Answers", "Any Document"],
//       route:       "/document-chat",
//     },
//     {
//     id:          "resume_from_scratch",
//     serviceCode: "RESUME_FROM_SCRATCH",
//     planId:      "ats_basic",
//     isFree:      true,
//     icon:        "📝",
//     title:       "Resume Builder",
//     description: "No resume? No problem. Pick your field, experience level, and a job description — we'll build a professional ATS resume from scratch.",
//     badge:       "FREE",
//     badgeColor:  "#3B6D11",
//     badgeBg:     "#EAF3DE",
//     active:      true,
//     enabled:     true,
//     comingSoon:  false,
//     highlights:  ["No resume needed", "5 Templates", "ATS Optimized"],
//     route:       "/build-resume",
//   },
//   ],

//   // ─────────────────────────────────────────────────────────────
//   // HOW IT WORKS STEPS
//   // ─────────────────────────────────────────────────────────────
//   steps: [
//     { num: "1", icon: "🎯", label: "Select Plan",              desc: "Choose the plan you need."            },
//     { num: "2", icon: "💳", label: "Pay",                      desc: "One-time payment, no subscriptions.", priceRef: true },
//     { num: "3", icon: "📄", label: "Upload Resume / Document", desc: "Word, PDF, or paste text."            },
//     { num: "4", icon: "📋", label: "Paste Job Description",    desc: "Copy from any job board."             },
//     { num: "5", icon: "🚀", label: "Get Your Results",         desc: "Download, chat, or analyze."          },
//   ],

//   // ─────────────────────────────────────────────────────────────
//   // STATS
//   // ─────────────────────────────────────────────────────────────
//   stats: [
//     { value: "90%+",  label: "ATS Compatibility Rate"  },
//     { value: "$1.99", label: "Starting Price"           },
//     { value: "60s",   label: "Average Analysis Time"    },
//     { value: "5",     label: "Professional Templates"   },
//   ],

//   // ─────────────────────────────────────────────────────────────
//   // FAQ
//   // ─────────────────────────────────────────────────────────────
//   faq: [
//     {
//       q: "What is an ATS score?",
//       a: "An ATS (Applicant Tracking System) score measures how well your resume matches a job description. Most companies use ATS software to filter resumes before a human sees them. A higher score means more chances of getting noticed.",
//     },
//     {
//       q: "What does ATS Basic include?",
//       a: "ATS Basic ($1.99) includes 2 ATS resume analyses with scoring, keyword gap analysis, section feedback, AI rewrite suggestions, and one free AI-improved resume generator with access to 5 professional templates. Also includes 1 cover letter generation.",
//     },
//     {
//       q: "What resume templates are available?",
//       a: "ATS Basic includes 5 fully supported templates: Classic ATS, Executive, Bold Impact, Minimal Clean, and Professional. All templates produce identical output across PDF, Word, and HTML downloads.",
//     },
//     {
//       q: "Will the downloaded resume match what I see on screen?",
//       a: "Yes — PDF, Word, and HTML downloads all use the same HTML generator as the screen preview, so what you see is exactly what you get.",
//     },
//     {
//       q: "Is there a subscription?",
//       a: "No subscriptions. Each plan is a one-time payment, only when you need it.",
//     },
//     {
//       q: "What file formats are supported for upload?",
//       a: "Resume analysis: Word (.docx) or paste plain text. Downloaded resumes are available in PDF, Word (.doc), or HTML.",
//     },
//     {
//       q: "Are the plans cumulative?",
//       a: "No — each plan is independent. You pay for what you need.",
//     },
//     {
//       q: "Is my data secure?",
//       a: "Yes. Your data is stored securely and never shared with third parties. Payments are processed by Stripe with bank-level encryption.",
//     },
//     {
//       q: "What does Document Pro include?",
//       a: "Document Pro includes AI-powered document summarization with visual charts, key points extraction, and an interactive Q&A chat. Coming soon!",
//     },
//   ],
// };

// export default servicesConfig;

// added new code with template comparision
const servicesConfig = {


    // ─────────────────────────────────────────────────────────────
  // TEMPLATE COMPARISON & RATINGS
  // Single source of truth for template comparisons shown on landing page
  // ─────────────────────────────────────────────────────────────
  templateComparison: {
    // Global ATS compatibility note
    atsCompatibilityNote: {
      bestForATS: "classic",  // template id with highest ATS score
      proTip: "Classic ATS has the highest ATS score (5/5) due to its simple single-column layout, standard Times New Roman font, and absence of complex formatting. It's the safest choice for older ATS systems like Taleo, BrassRing, and iCIMS.",
      comingSoonPlainText: true,
      plainTextStatus: "Coming soon: Plain text (.txt) export option for maximum compatibility with older ATS systems that struggle with HTML/CSS parsing. All templates will support this fallback format.",
    },
    
    // Rating scale definitions
    ratingScale: {
      5: { stars: "⭐⭐⭐⭐⭐", label: "Excellent", color: "#10b981" },
      4: { stars: "⭐⭐⭐⭐", label: "Good", color: "#3b82f6" },
      3: { stars: "⭐⭐⭐", label: "Average", color: "#f59e0b" },
      2: { stars: "⭐⭐", label: "Fair", color: "#ef4444" },
      1: { stars: "⭐", label: "Poor", color: "#ef4444" },
    },

    // Individual template ratings and metadata
    templates: [
      {
        id: "classic",
        name: "Classic ATS",
        styleDescription: "Harvard-style centered header · Ruled section dividers · Clean serif typography",
        atsScore: 5,
        professionalScore: 5,
        professionalLookLabel: "Clean, traditional",
        bestFor: ["Finance", "Law", "Healthcare", "Government"],
        bestForColors: ["#e0f2fe", "#e0f2fe", "#e0f2fe", "#e0f2fe"],
        accentColor: "#2563eb",
        keyFeatures: [
          "Times New Roman font (most ATS-friendly)",
          "Single-column layout",
          "Standard section headings",
          "No complex formatting"
        ],
        recommended: true,
      },
      {
        id: "executive",
        name: "Executive",
        styleDescription: "Premium serif · Double-rule divider · Elegant spacing",
        atsScore: 4,
        professionalScore: 4,
        professionalLookLabel: "Elegant serif",
        bestFor: ["C-Suite", "Director", "Management", "Senior Leadership"],
        bestForColors: ["#f3e8ff", "#f3e8ff", "#f3e8ff", "#f3e8ff"],
        accentColor: "#1e293b",
        keyFeatures: [
          "Georgia/Times New Roman font",
          "Double-rule header divider",
          "Executive spacing",
          "Professional typography"
        ],
        recommended: false,
      },
      {
        id: "bold",
        name: "Bold Impact",
        styleDescription: "Modern sans-serif · Accent color rule · Strong typography",
        atsScore: 3,
        professionalScore: 5,
        professionalLookLabel: "Modern, confident",
        bestFor: ["Sales", "Marketing", "Operations", "Creative Roles"],
        bestForColors: ["#fef3c7", "#fef3c7", "#fef3c7", "#fef3c7"],
        accentColor: "#1d4ed8",
        keyFeatures: [
          "Segoe UI / Roboto font",
          "Bold accent color highlights",
          "Clean lines",
          "Modern aesthetic"
        ],
        recommended: false,
      },
      {
        id: "minimal",
        name: "Minimal Clean",
        styleDescription: "Modern minimalist · Generous spacing · Clean aesthetics",
        atsScore: 4,
        professionalScore: 4,
        professionalLookLabel: "Modern but safe",
        bestFor: ["Tech", "Remote Roles", "Startups", "Creative Industries"],
        bestForColors: ["#dcfce7", "#dcfce7", "#dcfce7", "#dcfce7"],
        accentColor: "#047857",
        keyFeatures: [
          "Inter / Segoe UI font",
          "Lightweight design",
          "Generous white space",
          "Modern minimalist"
        ],
        recommended: false,
      },
      {
        id: "professional",
        name: "Professional",
        styleDescription: "Corporate standard Arial · Clean lines · Universal compatibility",
        atsScore: 4,
        professionalScore: 4,
        professionalLookLabel: "Corporate standard",
        bestFor: ["Banking", "Consulting", "Corporate", "Insurance"],
        bestForColors: ["#dbeafe", "#dbeafe", "#dbeafe", "#dbeafe"],
        accentColor: "#0f172a",
        keyFeatures: [
          "Arial / Helvetica font",
          "Corporate standard layout",
          "Universal ATS compatibility",
          "Professional appearance"
        ],
        recommended: false,
      },
    ],

    // Quick recommendation cards shown below the table
    recommendations: [
      {
        id: "best_ats",
        icon: "🏆",
        title: "Best for ATS",
        templateId: "classic",
        description: "Highest ATS score — safest choice for any industry",
      },
      {
        id: "best_corporate",
        icon: "💼",
        title: "Best for Corporate",
        templateId: "professional",
        description: "Standard Arial font, clean lines — preferred by banks & consultancies",
      },
      {
        id: "best_executive",
        icon: "👔",
        title: "Best for Executive",
        templateId: "executive",
        description: "Premium serif — makes a strong impression for senior roles",
      },
      {
        id: "most_modern",
        icon: "✨",
        title: "Most Modern",
        templateId: "bold",
        description: "Bold accents — stands out while staying professional",
      },
    ],
  },

  // ─────────────────────────────────────────────────────────────
  // APP BRANDING — change here, updates everywhere automatically
  // ─────────────────────────────────────────────────────────────
  app: {
    name:        "ResumeScoreAI",
    tagline:     "Beat the ATS. Get the interview.",        // ← hero headline suffix
    taglinePre:  "Beat the ATS.",                           // ← line 1 of split tagline
    taglinePost: "Get the interview.",                      // ← line 2 of split tagline
    description: "AI-powered ATS resume analysis and generation — beat the ATS, get the interview.",
    shortDesc:   "Beat the ATS. Get the interview.",        // ← used in meta, footer
    ctaHero:     "Analyze My Resume",                       // ← primary CTA button text
    ctaNav:      "Get Started Free",                        // ← nav CTA for logged-out
    ctaNavUser:  "New Analysis",                            // ← nav CTA for logged-in
    supportHours:"48 hours",                                // ← support response time
    domain:      "smartaicareer.com",
    email:       "support@smartaicareer.com",
    twitter:     "",
    linkedin:    "",
  },

  // ─────────────────────────────────────────────────────────────
  // RESUME TEMPLATES
  // Single source of truth for all available templates.
  // Access per plan is controlled via plan.resumeTemplateIds[]
  // ─────────────────────────────────────────────────────────────
  // ─────────────────────────────────────────────────────────────
  // RESUME TEMPLATES
  //
  // Each template has these control flags:
  //   active:     true  → built, tested, available for use
  //               false → disabled globally (not shown anywhere)
  //   showInLanding: true  → shown in landing page carousel
  //   comingSoon: true  → show greyed-out with "Coming Soon" badge
  //
  // Plan access is controlled via plans[].resumeTemplateIds[]
  // To add a new template:
  //   1. Add entry here with active: false, comingSoon: true
  //   2. Build the renderer in TemplateMini.jsx, ResumePreview, generateResumeDoc.js
  //   3. Set active: true when ready
  //   4. Add id to relevant plan's resumeTemplateIds[]
  // ─────────────────────────────────────────────────────────────
  resumeTemplates: [
    {
      id:            "classic",
      name:          "Classic ATS",
      description:   "Clean single-column layout. Best for traditional industries.",
      tags:          ["Finance", "Law", "Healthcare"],
      accent:        "#2563eb",
      headerBg:      "#1e293b",
      active:        true,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "modern",
      name:          "Modern Pro",
      description:   "Bold sidebar with skill bars. Great for tech roles.",
      tags:          ["Tech", "Engineering", "Design"],
      accent:        "#7c3aed",
      headerBg:      "#7c3aed",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "executive",
      name:          "Executive",
      description:   "Dark full-width header for senior-level positions.",
      tags:          ["Management", "C-Suite", "Director"],
      accent:        "#334155",
      headerBg:      "#0f172a",
      active:        true,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "minimal",
      name:          "Minimal Clean",
      description:   "Ultra clean whitespace. Passes all ATS scanners easily.",
      tags:          ["Any Industry", "Entry Level", "Remote"],
      accent:        "#059669",
      headerBg:      "#059669",
      active:        true,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "corporate",
      name:          "Corporate",
      description:   "Gradient header with professional layout for business roles.",
      tags:          ["Business", "Consulting", "Banking"],
      accent:        "#0369a1",
      headerBg:      "#0c4a6e",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "creative",
      name:          "Creative",
      description:   "Bold diagonal header with color accents for creative roles.",
      tags:          ["Marketing", "Design", "Media"],
      accent:        "#e11d48",
      headerBg:      "#881337",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "technical",
      name:          "Technical",
      description:   "Code-style layout optimized for engineers and developers.",
      tags:          ["Engineering", "Software", "Data Science"],
      accent:        "#0891b2",
      headerBg:      "#164e63",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "elegant",
      name:          "Elegant",
      description:   "Refined serif typography with a tasteful two-tone sidebar accent.",
      tags:          ["Finance", "Law", "Consulting"],
      accent:        "#b45309",
      headerBg:      "#1c1917",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "bold",
      name:          "Bold Impact",
      description:   "Large name, strong section dividers. Stands out in any stack.",
      tags:          ["Sales", "Marketing", "Operations"],
      accent:        "#1d4ed8",
      headerBg:      "#1e3a8a",
      active:        true,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "sidebarlight",
      name:          "Sidebar Light",
      description:   "Clean light sidebar with contact info. Balanced and modern.",
      tags:          ["Product", "Design", "HR"],
      accent:        "#0d9488",
      headerBg:      "#f0fdfa",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "academic",
      name:          "Academic",
      description:   "Formal layout for research, academia, and PhD applications.",
      tags:          ["Research", "Academia", "Science"],
      accent:        "#7c3aed",
      headerBg:      "#1e1b4b",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "professional",
      name:          "Professional",
      description:   "Traditional two-column header, clean lines. Universal ATS compatibility.",
      tags:          ["Finance", "Banking", "Insurance"],
      accent:        "#1e3a5f",
      headerBg:      "#1e3a5f",
      active:        true,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "compact",
      name:          "Compact",
      description:   "Fits more content per page. Ideal for experienced professionals.",
      tags:          ["Senior", "Management", "10+ Years"],
      accent:        "#374151",
      headerBg:      "#111827",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "cleanserif",
      name:          "Clean Serif",
      description:   "Warm serif fonts with generous spacing. Great for non-tech industries.",
      tags:          ["Healthcare", "Education", "Nonprofit"],
      accent:        "#7f1d1d",
      headerBg:      "#450a0a",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    {
      id:            "government",
      name:          "Government",
      description:   "Strict formatting for federal and government job applications.",
      tags:          ["Federal", "Public Sector", "Military"],
      accent:        "#1e3a5f",
      headerBg:      "#0f2137",
      active:        false,
      showInLanding: true,
      comingSoon:    false,
    },
    // ── Future templates — set active:false until renderer is built ──
    // {
    //   id:            "infographic",
    //   name:          "Infographic",
    //   description:   "Visual icons and charts for data-heavy profiles.",
    //   tags:          ["Data", "Analytics", "Research"],
    //   accent:        "#f59e0b",
    //   headerBg:      "#92400e",
    //   active:        false,
    //   showInLanding: false,
    //   comingSoon:    true,
    // },
  ],

  // ─────────────────────────────────────────────────────────────
  // PLANS — each plan is fully independent
  // resumeTemplateIds  → which templates this plan unlocks
  // resumeTemplateCount → how many templates user can SELECT
  //   (null = unlimited, 1 = pick 1, 2 = pick any 2, etc.)
  // ─────────────────────────────────────────────────────────────
  plans: [

    // ── PLAN 1: ATS Basic ──────────────────────────────────────
    {
      id:           "ats_basic",
      name:         "ATS Basic",
      price:        "$4.99",
      priceInCents: 499,
      period:       "one-time",
      description:  "2 ATS analyses + 1 AI-improved resume using your real data in your chosen template.",
      highlight:    false,
      badge:        null,
      enabled:      true,
      active:       true,
      includes: [
        "ATS_ANALYSIS",
        "ATS_RESUME_IMPROVED", // renamed from SAMPLE — now uses real resume data
        "ATS_RESUME_GENERATION",
        "AI COVER LETTER",
      ],

      // ── Usage limits (configurable here) ──
      analysisCount:    3,  // how many ATS analyses allowed per purchase
      resumeGenCount:   1,  // how many resume generations allowed per purchase
      coverLetterCount: 1,  // how many cover letters allowed per purchase
      scratchResumeCount: 1,  // how many "build from scratch" resumes allowed per purchase


      // ── Template access ──
      // List ONLY the template ids this plan allows.
      // Users see exactly these templates during resume generation.
      // To add/remove: edit the array below and redeploy frontend only.
      // Upgrade plans can have more templates (e.g. doc_pro gets all 7).
      // Only templates with full download support (PDF/Word/HTML all match preview exactly)
      resumeTemplateIds:   ["classic", "executive", "bold", "minimal", "professional"],
      resumeTemplateCount: 1,  // user picks 1 template per generation

      features: [
        { text: "3 ATS Analyses per purchase",        included: true  },
        { text: "Full ATS Score (0–100)",              included: true  },
        { text: "Keyword Gap Analysis",                included: true  },
        { text: "Section-by-Section Feedback",         included: true  },
        { text: "AI Rewrite Suggestions",              included: true  },
        { text: "Downloadable Analysis Report",        included: true  },
        { text: "1 AI-Improved Resume (Multiple Templates)",  included: true  },
        { text: "1 AI-Powered Resume (Multiple Templates) from scratch - Free",  included: true  },
        { text: "1 AI-Powered cover letter - Free",  included: true  },
        { text: "Uses YOUR real resume data",          included: true  },
        { text: "Missing keywords auto-injected",      included: true  },
        { text: "Document Summary & Charts",           included: false },
        { text: "Document Chat / Q&A",                 included: false },
      ],
      cta:      "Get Started",
      ctaRoute: "/signup",
    },

    // ── PLAN 2: Document Pro ───────────────────────────────────
    {
      id:           "doc_pro",
      name:         "Document Pro",
      price:        "$5.99",
      priceInCents: 599,
      period:       "one-time",
      description:  "AI-powered document summary with charts and interactive Q&A chat.",
      highlight:    true,
      badge:        "Coming Soon",
      enabled:      true,
      active:       false,
      includes: [
        "DOCUMENT_SUMMARY",
        "DOCUMENT_CHAT",
        "ATS_ANALYSIS",
        "ATS_RESUME_SAMPLE",
      ],
      // ── Usage limits ──
      analysisCount:    3,  // doc_pro gets more analyses
      resumeGenCount:   1,

      // ── Template access ──
      // ── Template access — doc_pro gets ALL templates as upgrade incentive ──
      resumeTemplateIds: [
        "classic", "executive", "bold", "minimal", "professional"
      ],
      resumeTemplateCount: 1,
      features: [
        { text: "Upload Any Document (PDF, Word)",        included: true  },
        { text: "AI Document Summary",                    included: true  },
        { text: "Key Points Extraction",                  included: true  },
        { text: "Visual Charts & Insights",               included: true  },
        { text: "Document Chat / Q&A",                    included: true  },
        { text: "3 ATS Resume Analyses",                  included: true  },
        { text: "1 AI-Improved Resume (5 Templates)",     included: true  },
        { text: "Cover Letter Generator",                 included: true  },
      ],
      cta:      "Notify Me",
      ctaRoute: "/support",
    },
  ],

  // ─────────────────────────────────────────────────────────────
  // SERVICES
  // ─────────────────────────────────────────────────────────────
  services: [
    {
      id:          "ats_analysis",
      serviceCode: "ATS_ANALYSIS",
      planId:      "ats_basic",
      isFree:      false,
      icon:        "🎯",
      title:       "ATS Resume Analysis",
      description: "Detailed ATS score, keyword gap analysis, section feedback and AI rewrite suggestions.",
      badge:       null,
      active:      true,
      enabled:     true,
      comingSoon:  false,
      highlights:  ["ATS Score 0–100", "Keyword Gap Analysis", "AI Feedback"],
      route:       null,
    },
    {
      id:          "ats_resume_improved",
      serviceCode: "ATS_RESUME_IMPROVED",
      planId:      "ats_basic",
      isFree:      true,
      icon:        "✨",
      title:       "AI-Improved Resume",
      description: "Generate an ATS-optimized resume using your real data in your chosen template.",
      badge:       "FREE",
      badgeColor:  "#3B6D11",
      badgeBg:     "#EAF3DE",
      active:      true,
      enabled:     true,
      comingSoon:  false,
      highlights:  ["5 Pro Templates", "AI-Powered", "PDF + Word + HTML"],
      route:       "/generate-resume",
    },
    {
      id:          "cover_letter",
      serviceCode: "COVER_LETTER",
      planId:      "ats_basic",
      isFree:      true,
      icon:        "📝",
      title:       "Cover Letter Generator",
      description: "AI-generated cover letter tailored to the job description.",
      badge:       "FREE",
      badgeColor:  "#3B6D11",
      badgeBg:     "#EAF3DE",
      active:      true,
      enabled:     true,
      comingSoon:  false,
      highlights:  ["AI-Powered", "Job Tailored", "PDF + Word + TXT"],
      route:       "/cover-letter",
    },
    {
      id:          "document_summary",
      serviceCode: "DOCUMENT_SUMMARY",
      planId:      "doc_pro",
      isFree:      false,
      icon:        "📊",
      title:       "Document Summary",
      description: "Upload any document and get an AI summary with visual charts and key insights.",
      badge:       null,
      active:      false,
      enabled:     true,
      comingSoon:  true,
      highlights:  ["AI Summary", "Visual Charts", "Key Points"],
      route:       "/document-summary",
    },
    {
      id:          "document_chat",
      serviceCode: "DOCUMENT_CHAT",
      planId:      "doc_pro",
      isFree:      false,
      icon:        "💬",
      title:       "Document Chat",
      description: "Ask questions and have a conversation with any document using AI.",
      badge:       null,
      active:      false,
      enabled:     true,
      comingSoon:  true,
      highlights:  ["Ask Questions", "AI Answers", "Any Document"],
      route:       "/document-chat",
    },
    {
    id:          "resume_from_scratch",
    serviceCode: "RESUME_FROM_SCRATCH",
    planId:      "ats_basic",
    isFree:      true,
    icon:        "📝",
    title:       "Resume Builder",
    description: "No resume? No problem. Pick your field, experience level, and a job description — we'll build a professional ATS resume from scratch.",
    badge:       "FREE",
    badgeColor:  "#3B6D11",
    badgeBg:     "#EAF3DE",
    active:      true,
    enabled:     true,
    comingSoon:  false,
    highlights:  ["No resume needed", "5 Templates", "ATS Optimized"],
    route:       "/build-resume",
  },
  ],

  // ─────────────────────────────────────────────────────────────
  // HOW IT WORKS STEPS
  // ─────────────────────────────────────────────────────────────
  steps: [
    { num: "1", icon: "🎯", label: "Select Plan",              desc: "Choose the plan you need."            },
    { num: "2", icon: "💳", label: "Pay",                      desc: "One-time payment, no subscriptions.", priceRef: true },
    { num: "3", icon: "📄", label: "Upload Resume / Document", desc: "Word, PDF, or paste text."            },
    { num: "4", icon: "📋", label: "Paste Job Description",    desc: "Copy from any job board."             },
    { num: "5", icon: "🚀", label: "Get Your Results",         desc: "Download, chat, or analyze."          },
  ],

  // ─────────────────────────────────────────────────────────────
  // STATS
  // ─────────────────────────────────────────────────────────────
  stats: [
    { value: "90%+",  label: "ATS Compatibility Rate"  },
    { value: "$1.99", label: "Starting Price"           },
    { value: "60s",   label: "Average Analysis Time"    },
    { value: "5",     label: "Professional Templates"   },
  ],

  // ─────────────────────────────────────────────────────────────
  // FAQ
  // ─────────────────────────────────────────────────────────────
  faq: [
    {
      q: "What is an ATS score?",
      a: "An ATS (Applicant Tracking System) score measures how well your resume matches a job description. Most companies use ATS software to filter resumes before a human sees them. A higher score means more chances of getting noticed.",
    },
    {
      q: "What does ATS Basic include?",
      a: "ATS Basic ($4.99) includes 2 ATS resume analyses with scoring, keyword gap analysis, section feedback, AI rewrite suggestions, and one free AI-improved resume generator with access to 5 professional templates. Also includes 1 cover letter generation.",
    },
    {
      q: "What resume templates are available?",
      a: "ATS Basic includes 5 fully supported templates: Classic ATS, Executive, Bold Impact, Minimal Clean, and Professional. All templates produce identical output across PDF, Word, and HTML downloads.",
    },
    {
      q: "Will the downloaded resume match what I see on screen?",
      a: "Yes — PDF, Word, and HTML downloads all use the same HTML generator as the screen preview, so what you see is exactly what you get.",
    },
    {
      q: "Is there a subscription?",
      a: "No subscriptions. Each plan is a one-time payment, only when you need it.",
    },
    {
      q: "What file formats are supported for upload?",
      a: "Resume analysis: Word (.docx) or paste plain text. Downloaded resumes are available in PDF, Word (.doc), or HTML.",
    },
    {
      q: "Are the plans cumulative?",
      a: "No — each plan is independent. You pay for what you need.",
    },
    {
      q: "Is my data secure?",
      a: "Yes. Your data is stored securely and never shared with third parties. Payments are processed by Stripe with bank-level encryption.",
    },
    {
      q: "What does Document Pro include?",
      a: "Document Pro includes AI-powered document summarization with visual charts, key points extraction, and an interactive Q&A chat. Coming soon!",
    },
  ],
};

export default servicesConfig;
